import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * A date-time string at UTC, such as 2007-12-03T10:15:30Z,
   *     compliant with the 'date-time' format outlined in section 5.6 of
   *     the RFC 3339 profile of the ISO 8601 standard for representation
   *     of dates and times using the Gregorian calendar.
   */
  DateTime: string;
  /** The 'Dimension' type represents dimensions as whole numeric values between `1` and `4000`. */
  Dimension: number;
  /** The 'Quality' type represents quality as whole numeric values between `1` and `100`. */
  Quality: number;
  /** The 'HexColor' type represents color in `rgb:ffffff` string format. */
  HexColor: string;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: Record<string, unknown>;
};

export type QueryType = {
  readonly __typename?: 'Query';
  readonly asset: Maybe<AssetType>;
  readonly assetCollection: Maybe<AssetCollectionType>;
  readonly globalNavConfig: Maybe<GlobalNavConfigType>;
  readonly globalNavConfigCollection: Maybe<GlobalNavConfigCollectionType>;
  readonly cookieModal: Maybe<CookieModalType>;
  readonly cookieModalCollection: Maybe<CookieModalCollectionType>;
  readonly trackingCookie: Maybe<TrackingCookieType>;
  readonly trackingCookieCollection: Maybe<TrackingCookieCollectionType>;
  readonly image: Maybe<ImageType>;
  readonly imageCollection: Maybe<ImageCollectionType>;
  readonly globalNavHighlight: Maybe<GlobalNavHighlightType>;
  readonly globalNavHighlightCollection: Maybe<GlobalNavHighlightCollectionType>;
  readonly globalNav: Maybe<GlobalNavType>;
  readonly globalNavCollection: Maybe<GlobalNavCollectionType>;
  readonly cookieCategory: Maybe<CookieCategoryType>;
  readonly cookieCategoryCollection: Maybe<CookieCategoryCollectionType>;
  readonly footerV3: Maybe<FooterV3Type>;
  readonly footerV3Collection: Maybe<FooterV3CollectionType>;
  readonly footerItemV3: Maybe<FooterItemV3Type>;
  readonly footerItemV3Collection: Maybe<FooterItemV3CollectionType>;
  readonly footerLocaleDropdown: Maybe<FooterLocaleDropdownType>;
  readonly footerLocaleDropdownCollection: Maybe<FooterLocaleDropdownCollectionType>;
  readonly footerCookiesSettingsLink: Maybe<FooterCookiesSettingsLinkType>;
  readonly footerCookiesSettingsLinkCollection: Maybe<FooterCookiesSettingsLinkCollectionType>;
  readonly footerGroup: Maybe<FooterGroupType>;
  readonly footerGroupCollection: Maybe<FooterGroupCollectionType>;
  readonly cookieBanner: Maybe<CookieBannerType>;
  readonly cookieBannerCollection: Maybe<CookieBannerCollectionType>;
  readonly footer: Maybe<FooterType>;
  readonly footerCollection: Maybe<FooterCollectionType>;
  readonly analytics: Maybe<AnalyticsType>;
  readonly analyticsCollection: Maybe<AnalyticsCollectionType>;
  readonly globalNavItem: Maybe<GlobalNavItemType>;
  readonly globalNavItemCollection: Maybe<GlobalNavItemCollectionType>;
  readonly button: Maybe<ButtonType>;
  readonly buttonCollection: Maybe<ButtonCollectionType>;
  readonly callToAction: Maybe<CallToActionType>;
  readonly callToActionCollection: Maybe<CallToActionCollectionType>;
  readonly message: Maybe<MessageType>;
  readonly messageCollection: Maybe<MessageCollectionType>;
  readonly legalMessage: Maybe<LegalMessageType>;
  readonly legalMessageCollection: Maybe<LegalMessageCollectionType>;
  readonly video: Maybe<VideoType>;
  readonly videoCollection: Maybe<VideoCollectionType>;
  readonly footerItem: Maybe<FooterItemType>;
  readonly footerItemCollection: Maybe<FooterItemCollectionType>;
  readonly entryCollection: Maybe<EntryCollectionType>;
  readonly _node: Maybe<_NodeType>;
};


export type QueryAssetArgsType = {
  id: Scalars['String'];
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type QueryAssetCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<AssetFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<AssetOrderType>>>;
};


export type QueryGlobalNavConfigArgsType = {
  id: Scalars['String'];
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type QueryGlobalNavConfigCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<GlobalNavConfigFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<GlobalNavConfigOrderType>>>;
};


export type QueryCookieModalArgsType = {
  id: Scalars['String'];
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type QueryCookieModalCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<CookieModalFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<CookieModalOrderType>>>;
};


export type QueryTrackingCookieArgsType = {
  id: Scalars['String'];
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type QueryTrackingCookieCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<TrackingCookieFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<TrackingCookieOrderType>>>;
};


export type QueryImageArgsType = {
  id: Scalars['String'];
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type QueryImageCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<ImageFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<ImageOrderType>>>;
};


export type QueryGlobalNavHighlightArgsType = {
  id: Scalars['String'];
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type QueryGlobalNavHighlightCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<GlobalNavHighlightFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<GlobalNavHighlightOrderType>>>;
};


export type QueryGlobalNavArgsType = {
  id: Scalars['String'];
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type QueryGlobalNavCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<GlobalNavFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<GlobalNavOrderType>>>;
};


export type QueryCookieCategoryArgsType = {
  id: Scalars['String'];
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type QueryCookieCategoryCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<CookieCategoryFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<CookieCategoryOrderType>>>;
};


export type QueryFooterV3ArgsType = {
  id: Scalars['String'];
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type QueryFooterV3CollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<FooterV3FilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<FooterV3OrderType>>>;
};


export type QueryFooterItemV3ArgsType = {
  id: Scalars['String'];
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type QueryFooterItemV3CollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<FooterItemV3FilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<FooterItemV3OrderType>>>;
};


export type QueryFooterLocaleDropdownArgsType = {
  id: Scalars['String'];
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type QueryFooterLocaleDropdownCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<FooterLocaleDropdownFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<FooterLocaleDropdownOrderType>>>;
};


export type QueryFooterCookiesSettingsLinkArgsType = {
  id: Scalars['String'];
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type QueryFooterCookiesSettingsLinkCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<FooterCookiesSettingsLinkFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<FooterCookiesSettingsLinkOrderType>>>;
};


export type QueryFooterGroupArgsType = {
  id: Scalars['String'];
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type QueryFooterGroupCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<FooterGroupFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<FooterGroupOrderType>>>;
};


export type QueryCookieBannerArgsType = {
  id: Scalars['String'];
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type QueryCookieBannerCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<CookieBannerFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<CookieBannerOrderType>>>;
};


export type QueryFooterArgsType = {
  id: Scalars['String'];
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type QueryFooterCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<FooterFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<FooterOrderType>>>;
};


export type QueryAnalyticsArgsType = {
  id: Scalars['String'];
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type QueryAnalyticsCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<AnalyticsFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<AnalyticsOrderType>>>;
};


export type QueryGlobalNavItemArgsType = {
  id: Scalars['String'];
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type QueryGlobalNavItemCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<GlobalNavItemFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<GlobalNavItemOrderType>>>;
};


export type QueryButtonArgsType = {
  id: Scalars['String'];
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type QueryButtonCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<ButtonFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<ButtonOrderType>>>;
};


export type QueryCallToActionArgsType = {
  id: Scalars['String'];
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type QueryCallToActionCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<CallToActionFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<CallToActionOrderType>>>;
};


export type QueryMessageArgsType = {
  id: Scalars['String'];
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type QueryMessageCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<MessageFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<MessageOrderType>>>;
};


export type QueryLegalMessageArgsType = {
  id: Scalars['String'];
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type QueryLegalMessageCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<LegalMessageFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<LegalMessageOrderType>>>;
};


export type QueryVideoArgsType = {
  id: Scalars['String'];
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type QueryVideoCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<VideoFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<VideoOrderType>>>;
};


export type QueryFooterItemArgsType = {
  id: Scalars['String'];
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type QueryFooterItemCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<FooterItemFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<FooterItemOrderType>>>;
};


export type QueryEntryCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<EntryFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<EntryOrderType>>>;
};


export type Query_NodeArgsType = {
  id: Scalars['ID'];
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};

/** Represents a binary file in a space. An asset can be any file type. */
export type AssetType = {
  readonly __typename?: 'Asset';
  readonly sys: SysType;
  readonly contentfulMetadata: ContentfulMetadataType;
  readonly title: Maybe<Scalars['String']>;
  readonly description: Maybe<Scalars['String']>;
  readonly contentType: Maybe<Scalars['String']>;
  readonly fileName: Maybe<Scalars['String']>;
  readonly size: Maybe<Scalars['Int']>;
  readonly url: Maybe<Scalars['String']>;
  readonly width: Maybe<Scalars['Int']>;
  readonly height: Maybe<Scalars['Int']>;
  readonly linkedFrom: Maybe<AssetLinkingCollectionsType>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetTitleArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetDescriptionArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetContentTypeArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetFileNameArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetSizeArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetUrlArgsType = {
  transform: InputMaybe<ImageTransformOptionsType>;
  locale: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetWidthArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetHeightArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetLinkedFromArgsType = {
  allowedLocales: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export type SysType = {
  readonly __typename?: 'Sys';
  readonly id: Scalars['String'];
  readonly spaceId: Scalars['String'];
  readonly environmentId: Scalars['String'];
  readonly publishedAt: Maybe<Scalars['DateTime']>;
  readonly firstPublishedAt: Maybe<Scalars['DateTime']>;
  readonly publishedVersion: Maybe<Scalars['Int']>;
  /** The locale that was requested. */
  readonly locale: Maybe<Scalars['String']>;
};

export type ContentfulMetadataType = {
  readonly __typename?: 'ContentfulMetadata';
  readonly tags: ReadonlyArray<Maybe<ContentfulTagType>>;
  readonly concepts: ReadonlyArray<Maybe<TaxonomyConceptType>>;
};

/**
 * Represents a tag entity for finding and organizing content easily.
 *         Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-concepts
 */
export type TaxonomyConceptType = {
  readonly __typename?: 'TaxonomyConcept';
  readonly id: Maybe<Scalars['String']>;
};

/**
 * Represents a tag entity for finding and organizing content easily.
 *       Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-tags
 */
export type ContentfulTagType = {
  readonly __typename?: 'ContentfulTag';
  readonly id: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
};

export type ImageTransformOptionsType = {
  /** Desired width in pixels. Defaults to the original image width. */
  readonly width: InputMaybe<Scalars['Dimension']>;
  /** Desired height in pixels. Defaults to the original image height. */
  readonly height: InputMaybe<Scalars['Dimension']>;
  /**
   * Desired quality of the image in percents.
   *         Used for `PNG8`, `JPG`, `JPG_PROGRESSIVE` and `WEBP` formats.
   */
  readonly quality: InputMaybe<Scalars['Quality']>;
  /**
   * Desired corner radius in pixels.
   *         Results in an image with rounded corners (pass `-1` for a full circle/ellipse).
   *         Defaults to `0`. Uses desired background color as padding color,
   *         unless the format is `JPG` or `JPG_PROGRESSIVE` and resize strategy is `PAD`, then defaults to white.
   */
  readonly cornerRadius: InputMaybe<Scalars['Int']>;
  /** Desired resize strategy. Defaults to `FIT`. */
  readonly resizeStrategy: InputMaybe<ImageResizeStrategyType>;
  /** Desired resize focus area. Defaults to `CENTER`. */
  readonly resizeFocus: InputMaybe<ImageResizeFocusType>;
  /**
   * Desired background color, used with corner radius or `PAD` resize strategy.
   *         Defaults to transparent (for `PNG`, `PNG8` and `WEBP`) or white (for `JPG` and `JPG_PROGRESSIVE`).
   */
  readonly backgroundColor: InputMaybe<Scalars['HexColor']>;
  /** Desired image format. Defaults to the original image format. */
  readonly format: InputMaybe<ImageFormatType>;
};

export enum ImageResizeStrategyType {
  /** Resizes the image to fit into the specified dimensions. */
  FitType = 'FIT',
  /**
   * Resizes the image to the specified dimensions, padding the image if needed.
   *         Uses desired background color as padding color.
   */
  PadType = 'PAD',
  /** Resizes the image to the specified dimensions, cropping the image if needed. */
  FillType = 'FILL',
  /** Resizes the image to the specified dimensions, changing the original aspect ratio if needed. */
  ScaleType = 'SCALE',
  /** Crops a part of the original image to fit into the specified dimensions. */
  CropType = 'CROP',
  /** Creates a thumbnail from the image. */
  ThumbType = 'THUMB'
}

export enum ImageResizeFocusType {
  /** Focus the resizing on the center. */
  CenterType = 'CENTER',
  /** Focus the resizing on the top. */
  TopType = 'TOP',
  /** Focus the resizing on the top right. */
  TopRightType = 'TOP_RIGHT',
  /** Focus the resizing on the right. */
  RightType = 'RIGHT',
  /** Focus the resizing on the bottom right. */
  BottomRightType = 'BOTTOM_RIGHT',
  /** Focus the resizing on the bottom. */
  BottomType = 'BOTTOM',
  /** Focus the resizing on the bottom left. */
  BottomLeftType = 'BOTTOM_LEFT',
  /** Focus the resizing on the left. */
  LeftType = 'LEFT',
  /** Focus the resizing on the top left. */
  TopLeftType = 'TOP_LEFT',
  /** Focus the resizing on the largest face. */
  FaceType = 'FACE',
  /** Focus the resizing on the area containing all the faces. */
  FacesType = 'FACES'
}

export enum ImageFormatType {
  /** JPG image format. */
  JpgType = 'JPG',
  /**
   * Progressive JPG format stores multiple passes of an image in progressively higher detail.
   *         When a progressive image is loading, the viewer will first see a lower quality pixelated version which
   *         will gradually improve in detail, until the image is fully downloaded. This is to display an image as
   *         early as possible to make the layout look as designed.
   */
  JpgProgressiveType = 'JPG_PROGRESSIVE',
  /** PNG image format */
  PngType = 'PNG',
  /**
   * 8-bit PNG images support up to 256 colors and weigh less than the standard 24-bit PNG equivalent.
   *         The 8-bit PNG format is mostly used for simple images, such as icons or logos.
   */
  Png8Type = 'PNG8',
  /** WebP image format. */
  WebpType = 'WEBP',
  AvifType = 'AVIF'
}

export type AssetLinkingCollectionsType = {
  readonly __typename?: 'AssetLinkingCollections';
  readonly entryCollection: Maybe<EntryCollectionType>;
  readonly imageCollection: Maybe<ImageCollectionType>;
  readonly globalNavHighlightCollection: Maybe<GlobalNavHighlightCollectionType>;
  readonly cookieBannerCollection: Maybe<CookieBannerCollectionType>;
  readonly videoCollection: Maybe<VideoCollectionType>;
};


export type AssetLinkingCollectionsEntryCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type AssetLinkingCollectionsImageCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type AssetLinkingCollectionsGlobalNavHighlightCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type AssetLinkingCollectionsCookieBannerCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type AssetLinkingCollectionsVideoCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};

export type EntryCollectionType = {
  readonly __typename?: 'EntryCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<EntryType>>;
};

export type EntryType = {
  readonly sys: SysType;
  readonly contentfulMetadata: ContentfulMetadataType;
};

export type ImageCollectionType = {
  readonly __typename?: 'ImageCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<ImageType>>;
};

/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/image) */
export type ImageType = EntryType & _NodeType & {
  readonly __typename?: 'Image';
  readonly sys: SysType;
  readonly contentfulMetadata: ContentfulMetadataType;
  readonly linkedFrom: Maybe<ImageLinkingCollectionsType>;
  readonly _id: Scalars['ID'];
  readonly contentfulDescription: Maybe<Scalars['String']>;
  readonly media: Maybe<AssetType>;
  readonly wrap: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/image) */
export type ImageLinkedFromArgsType = {
  allowedLocales: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/image) */
export type ImageContentfulDescriptionArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/image) */
export type ImageMediaArgsType = {
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/image) */
export type ImageWrapArgsType = {
  locale: InputMaybe<Scalars['String']>;
};

export type _NodeType = {
  readonly _id: Scalars['ID'];
};

export type ImageLinkingCollectionsType = {
  readonly __typename?: 'ImageLinkingCollections';
  readonly entryCollection: Maybe<EntryCollectionType>;
  readonly footerV3Collection: Maybe<FooterV3CollectionType>;
  readonly buttonCollection: Maybe<ButtonCollectionType>;
};


export type ImageLinkingCollectionsEntryCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type ImageLinkingCollectionsFooterV3CollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<ReadonlyArray<InputMaybe<ImageLinkingCollectionsFooterV3CollectionOrderType>>>;
};


export type ImageLinkingCollectionsButtonCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<ReadonlyArray<InputMaybe<ImageLinkingCollectionsButtonCollectionOrderType>>>;
};

export type FooterV3CollectionType = {
  readonly __typename?: 'FooterV3Collection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<FooterV3Type>>;
};

/** Type for the new Footer V3 [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerV3) */
export type FooterV3Type = EntryType & _NodeType & {
  readonly __typename?: 'FooterV3';
  readonly sys: SysType;
  readonly contentfulMetadata: ContentfulMetadataType;
  readonly linkedFrom: Maybe<FooterV3LinkingCollectionsType>;
  readonly _id: Scalars['ID'];
  readonly contentfulDescription: Maybe<Scalars['String']>;
  readonly columnsCollection: Maybe<FooterV3ColumnsCollectionType>;
  readonly barCollection: Maybe<FooterV3BarCollectionType>;
  readonly logo: Maybe<ImageType>;
  readonly url: Maybe<Scalars['String']>;
  readonly hideLogoOnDomains: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
};


/** Type for the new Footer V3 [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerV3) */
export type FooterV3LinkedFromArgsType = {
  allowedLocales: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


/** Type for the new Footer V3 [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerV3) */
export type FooterV3ContentfulDescriptionArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** Type for the new Footer V3 [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerV3) */
export type FooterV3ColumnsCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<FooterGroupFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<FooterV3ColumnsCollectionOrderType>>>;
};


/** Type for the new Footer V3 [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerV3) */
export type FooterV3BarCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<FooterGroupFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<FooterV3BarCollectionOrderType>>>;
};


/** Type for the new Footer V3 [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerV3) */
export type FooterV3LogoArgsType = {
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<ImageFilterType>;
};


/** Type for the new Footer V3 [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerV3) */
export type FooterV3UrlArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** Type for the new Footer V3 [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerV3) */
export type FooterV3HideLogoOnDomainsArgsType = {
  locale: InputMaybe<Scalars['String']>;
};

export type FooterV3LinkingCollectionsType = {
  readonly __typename?: 'FooterV3LinkingCollections';
  readonly entryCollection: Maybe<EntryCollectionType>;
};


export type FooterV3LinkingCollectionsEntryCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};

export type FooterV3ColumnsCollectionType = {
  readonly __typename?: 'FooterV3ColumnsCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<FooterGroupType>>;
};

/** This model will hold and group footer items [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerGroup) */
export type FooterGroupType = EntryType & _NodeType & {
  readonly __typename?: 'FooterGroup';
  readonly sys: SysType;
  readonly contentfulMetadata: ContentfulMetadataType;
  readonly linkedFrom: Maybe<FooterGroupLinkingCollectionsType>;
  readonly _id: Scalars['ID'];
  readonly contentfulDescription: Maybe<Scalars['String']>;
  readonly title: Maybe<Scalars['String']>;
  readonly groupKey: Maybe<Scalars['String']>;
  readonly itemsCollection: Maybe<FooterGroupItemsCollectionType>;
  readonly analytics: Maybe<AnalyticsType>;
  readonly hideOnDomains: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
};


/** This model will hold and group footer items [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerGroup) */
export type FooterGroupLinkedFromArgsType = {
  allowedLocales: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


/** This model will hold and group footer items [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerGroup) */
export type FooterGroupContentfulDescriptionArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** This model will hold and group footer items [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerGroup) */
export type FooterGroupTitleArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** This model will hold and group footer items [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerGroup) */
export type FooterGroupGroupKeyArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** This model will hold and group footer items [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerGroup) */
export type FooterGroupItemsCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<FooterGroupItemsFilterType>;
};


/** This model will hold and group footer items [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerGroup) */
export type FooterGroupAnalyticsArgsType = {
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<AnalyticsFilterType>;
};


/** This model will hold and group footer items [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerGroup) */
export type FooterGroupHideOnDomainsArgsType = {
  locale: InputMaybe<Scalars['String']>;
};

export type FooterGroupLinkingCollectionsType = {
  readonly __typename?: 'FooterGroupLinkingCollections';
  readonly entryCollection: Maybe<EntryCollectionType>;
  readonly footerV3Collection: Maybe<FooterV3CollectionType>;
};


export type FooterGroupLinkingCollectionsEntryCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type FooterGroupLinkingCollectionsFooterV3CollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<ReadonlyArray<InputMaybe<FooterGroupLinkingCollectionsFooterV3CollectionOrderType>>>;
};

export enum FooterGroupLinkingCollectionsFooterV3CollectionOrderType {
  ContentfulDescriptionAscType = 'contentfulDescription_ASC',
  ContentfulDescriptionDescType = 'contentfulDescription_DESC',
  UrlAscType = 'url_ASC',
  UrlDescType = 'url_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export type FooterGroupItemsCollectionType = {
  readonly __typename?: 'FooterGroupItemsCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<FooterGroupItemsItemType>>;
};

export type FooterGroupItemsItemType = FooterCookiesSettingsLinkType | FooterItemV3Type | FooterLocaleDropdownType;

/** Footer Cookie Settings Link model [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerCookiesSettingsLink) */
export type FooterCookiesSettingsLinkType = EntryType & _NodeType & {
  readonly __typename?: 'FooterCookiesSettingsLink';
  readonly sys: SysType;
  readonly contentfulMetadata: ContentfulMetadataType;
  readonly linkedFrom: Maybe<FooterCookiesSettingsLinkLinkingCollectionsType>;
  readonly _id: Scalars['ID'];
  readonly contentfulDescription: Maybe<Scalars['String']>;
  readonly title: Maybe<Scalars['String']>;
  readonly hideOnDomains: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly analytics: Maybe<AnalyticsType>;
};


/** Footer Cookie Settings Link model [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerCookiesSettingsLink) */
export type FooterCookiesSettingsLinkLinkedFromArgsType = {
  allowedLocales: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


/** Footer Cookie Settings Link model [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerCookiesSettingsLink) */
export type FooterCookiesSettingsLinkContentfulDescriptionArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** Footer Cookie Settings Link model [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerCookiesSettingsLink) */
export type FooterCookiesSettingsLinkTitleArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** Footer Cookie Settings Link model [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerCookiesSettingsLink) */
export type FooterCookiesSettingsLinkHideOnDomainsArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** Footer Cookie Settings Link model [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerCookiesSettingsLink) */
export type FooterCookiesSettingsLinkAnalyticsArgsType = {
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<AnalyticsFilterType>;
};

export type FooterCookiesSettingsLinkLinkingCollectionsType = {
  readonly __typename?: 'FooterCookiesSettingsLinkLinkingCollections';
  readonly entryCollection: Maybe<EntryCollectionType>;
  readonly footerGroupCollection: Maybe<FooterGroupCollectionType>;
};


export type FooterCookiesSettingsLinkLinkingCollectionsEntryCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type FooterCookiesSettingsLinkLinkingCollectionsFooterGroupCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<ReadonlyArray<InputMaybe<FooterCookiesSettingsLinkLinkingCollectionsFooterGroupCollectionOrderType>>>;
};

export type FooterGroupCollectionType = {
  readonly __typename?: 'FooterGroupCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<FooterGroupType>>;
};

export enum FooterCookiesSettingsLinkLinkingCollectionsFooterGroupCollectionOrderType {
  ContentfulDescriptionAscType = 'contentfulDescription_ASC',
  ContentfulDescriptionDescType = 'contentfulDescription_DESC',
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  GroupKeyAscType = 'groupKey_ASC',
  GroupKeyDescType = 'groupKey_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/analytics) */
export type AnalyticsType = EntryType & _NodeType & {
  readonly __typename?: 'Analytics';
  readonly sys: SysType;
  readonly contentfulMetadata: ContentfulMetadataType;
  readonly linkedFrom: Maybe<AnalyticsLinkingCollectionsType>;
  readonly _id: Scalars['ID'];
  readonly label: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/analytics) */
export type AnalyticsLinkedFromArgsType = {
  allowedLocales: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/analytics) */
export type AnalyticsLabelArgsType = {
  locale: InputMaybe<Scalars['String']>;
};

export type AnalyticsLinkingCollectionsType = {
  readonly __typename?: 'AnalyticsLinkingCollections';
  readonly entryCollection: Maybe<EntryCollectionType>;
  readonly footerItemV3Collection: Maybe<FooterItemV3CollectionType>;
  readonly footerCookiesSettingsLinkCollection: Maybe<FooterCookiesSettingsLinkCollectionType>;
  readonly footerGroupCollection: Maybe<FooterGroupCollectionType>;
  readonly globalNavItemCollection: Maybe<GlobalNavItemCollectionType>;
  readonly callToActionCollection: Maybe<CallToActionCollectionType>;
  readonly footerItemCollection: Maybe<FooterItemCollectionType>;
};


export type AnalyticsLinkingCollectionsEntryCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type AnalyticsLinkingCollectionsFooterItemV3CollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<ReadonlyArray<InputMaybe<AnalyticsLinkingCollectionsFooterItemV3CollectionOrderType>>>;
};


export type AnalyticsLinkingCollectionsFooterCookiesSettingsLinkCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<ReadonlyArray<InputMaybe<AnalyticsLinkingCollectionsFooterCookiesSettingsLinkCollectionOrderType>>>;
};


export type AnalyticsLinkingCollectionsFooterGroupCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<ReadonlyArray<InputMaybe<AnalyticsLinkingCollectionsFooterGroupCollectionOrderType>>>;
};


export type AnalyticsLinkingCollectionsGlobalNavItemCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<ReadonlyArray<InputMaybe<AnalyticsLinkingCollectionsGlobalNavItemCollectionOrderType>>>;
};


export type AnalyticsLinkingCollectionsCallToActionCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<ReadonlyArray<InputMaybe<AnalyticsLinkingCollectionsCallToActionCollectionOrderType>>>;
};


export type AnalyticsLinkingCollectionsFooterItemCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<ReadonlyArray<InputMaybe<AnalyticsLinkingCollectionsFooterItemCollectionOrderType>>>;
};

export type FooterItemV3CollectionType = {
  readonly __typename?: 'FooterItemV3Collection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<FooterItemV3Type>>;
};

/** Footer item for the Footer - V3 [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerItemV3) */
export type FooterItemV3Type = EntryType & _NodeType & {
  readonly __typename?: 'FooterItemV3';
  readonly sys: SysType;
  readonly contentfulMetadata: ContentfulMetadataType;
  readonly linkedFrom: Maybe<FooterItemV3LinkingCollectionsType>;
  readonly _id: Scalars['ID'];
  readonly contentfulDescription: Maybe<Scalars['String']>;
  readonly title: Maybe<Scalars['String']>;
  readonly url: Maybe<Scalars['String']>;
  readonly analytics: Maybe<AnalyticsType>;
  readonly hideOnDomains: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
};


/** Footer item for the Footer - V3 [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerItemV3) */
export type FooterItemV3LinkedFromArgsType = {
  allowedLocales: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


/** Footer item for the Footer - V3 [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerItemV3) */
export type FooterItemV3ContentfulDescriptionArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** Footer item for the Footer - V3 [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerItemV3) */
export type FooterItemV3TitleArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** Footer item for the Footer - V3 [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerItemV3) */
export type FooterItemV3UrlArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** Footer item for the Footer - V3 [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerItemV3) */
export type FooterItemV3AnalyticsArgsType = {
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<AnalyticsFilterType>;
};


/** Footer item for the Footer - V3 [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerItemV3) */
export type FooterItemV3HideOnDomainsArgsType = {
  locale: InputMaybe<Scalars['String']>;
};

export type FooterItemV3LinkingCollectionsType = {
  readonly __typename?: 'FooterItemV3LinkingCollections';
  readonly entryCollection: Maybe<EntryCollectionType>;
  readonly footerGroupCollection: Maybe<FooterGroupCollectionType>;
};


export type FooterItemV3LinkingCollectionsEntryCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type FooterItemV3LinkingCollectionsFooterGroupCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<ReadonlyArray<InputMaybe<FooterItemV3LinkingCollectionsFooterGroupCollectionOrderType>>>;
};

export enum FooterItemV3LinkingCollectionsFooterGroupCollectionOrderType {
  ContentfulDescriptionAscType = 'contentfulDescription_ASC',
  ContentfulDescriptionDescType = 'contentfulDescription_DESC',
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  GroupKeyAscType = 'groupKey_ASC',
  GroupKeyDescType = 'groupKey_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export type AnalyticsFilterType = {
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly label_exists: InputMaybe<Scalars['Boolean']>;
  readonly label: InputMaybe<Scalars['String']>;
  readonly label_not: InputMaybe<Scalars['String']>;
  readonly label_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly label_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly label_contains: InputMaybe<Scalars['String']>;
  readonly label_not_contains: InputMaybe<Scalars['String']>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<AnalyticsFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<AnalyticsFilterType>>>;
};

export type SysFilterType = {
  readonly id_exists: InputMaybe<Scalars['Boolean']>;
  readonly id: InputMaybe<Scalars['String']>;
  readonly id_not: InputMaybe<Scalars['String']>;
  readonly id_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly id_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly id_contains: InputMaybe<Scalars['String']>;
  readonly id_not_contains: InputMaybe<Scalars['String']>;
  readonly publishedAt_exists: InputMaybe<Scalars['Boolean']>;
  readonly publishedAt: InputMaybe<Scalars['DateTime']>;
  readonly publishedAt_not: InputMaybe<Scalars['DateTime']>;
  readonly publishedAt_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['DateTime']>>>;
  readonly publishedAt_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['DateTime']>>>;
  readonly publishedAt_gt: InputMaybe<Scalars['DateTime']>;
  readonly publishedAt_gte: InputMaybe<Scalars['DateTime']>;
  readonly publishedAt_lt: InputMaybe<Scalars['DateTime']>;
  readonly publishedAt_lte: InputMaybe<Scalars['DateTime']>;
  readonly firstPublishedAt_exists: InputMaybe<Scalars['Boolean']>;
  readonly firstPublishedAt: InputMaybe<Scalars['DateTime']>;
  readonly firstPublishedAt_not: InputMaybe<Scalars['DateTime']>;
  readonly firstPublishedAt_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['DateTime']>>>;
  readonly firstPublishedAt_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['DateTime']>>>;
  readonly firstPublishedAt_gt: InputMaybe<Scalars['DateTime']>;
  readonly firstPublishedAt_gte: InputMaybe<Scalars['DateTime']>;
  readonly firstPublishedAt_lt: InputMaybe<Scalars['DateTime']>;
  readonly firstPublishedAt_lte: InputMaybe<Scalars['DateTime']>;
  readonly publishedVersion_exists: InputMaybe<Scalars['Boolean']>;
  readonly publishedVersion: InputMaybe<Scalars['Float']>;
  readonly publishedVersion_not: InputMaybe<Scalars['Float']>;
  readonly publishedVersion_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Float']>>>;
  readonly publishedVersion_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Float']>>>;
  readonly publishedVersion_gt: InputMaybe<Scalars['Float']>;
  readonly publishedVersion_gte: InputMaybe<Scalars['Float']>;
  readonly publishedVersion_lt: InputMaybe<Scalars['Float']>;
  readonly publishedVersion_lte: InputMaybe<Scalars['Float']>;
};

export type ContentfulMetadataFilterType = {
  readonly tags_exists: InputMaybe<Scalars['Boolean']>;
  readonly tags: InputMaybe<ContentfulMetadataTagsFilterType>;
  readonly concepts_exists: InputMaybe<Scalars['Boolean']>;
  readonly concepts: InputMaybe<ContentfulMetadataConceptsFilterType>;
};

export type ContentfulMetadataConceptsFilterType = {
  readonly id_contains_all: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly id_contains_some: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly id_contains_none: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly descendants: InputMaybe<ContentfulMetadataConceptsDescendantsFilterType>;
};

export type ContentfulMetadataConceptsDescendantsFilterType = {
  readonly id_contains_all: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly id_contains_some: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly id_contains_none: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export type ContentfulMetadataTagsFilterType = {
  readonly id_contains_all: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly id_contains_some: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly id_contains_none: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export enum AnalyticsLinkingCollectionsFooterItemV3CollectionOrderType {
  ContentfulDescriptionAscType = 'contentfulDescription_ASC',
  ContentfulDescriptionDescType = 'contentfulDescription_DESC',
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  UrlAscType = 'url_ASC',
  UrlDescType = 'url_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export type FooterCookiesSettingsLinkCollectionType = {
  readonly __typename?: 'FooterCookiesSettingsLinkCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<FooterCookiesSettingsLinkType>>;
};

export enum AnalyticsLinkingCollectionsFooterCookiesSettingsLinkCollectionOrderType {
  ContentfulDescriptionAscType = 'contentfulDescription_ASC',
  ContentfulDescriptionDescType = 'contentfulDescription_DESC',
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export enum AnalyticsLinkingCollectionsFooterGroupCollectionOrderType {
  ContentfulDescriptionAscType = 'contentfulDescription_ASC',
  ContentfulDescriptionDescType = 'contentfulDescription_DESC',
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  GroupKeyAscType = 'groupKey_ASC',
  GroupKeyDescType = 'groupKey_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export type GlobalNavItemCollectionType = {
  readonly __typename?: 'GlobalNavItemCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<GlobalNavItemType>>;
};

/** Individual link in the global nav. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/globalNavItem) */
export type GlobalNavItemType = EntryType & _NodeType & {
  readonly __typename?: 'GlobalNavItem';
  readonly sys: SysType;
  readonly contentfulMetadata: ContentfulMetadataType;
  readonly linkedFrom: Maybe<GlobalNavItemLinkingCollectionsType>;
  readonly _id: Scalars['ID'];
  readonly title: Maybe<Scalars['String']>;
  readonly url: Maybe<Scalars['String']>;
  readonly analytics: Maybe<AnalyticsType>;
  readonly hideHostnameRegex: Maybe<Scalars['String']>;
};


/** Individual link in the global nav. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/globalNavItem) */
export type GlobalNavItemLinkedFromArgsType = {
  allowedLocales: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


/** Individual link in the global nav. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/globalNavItem) */
export type GlobalNavItemTitleArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** Individual link in the global nav. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/globalNavItem) */
export type GlobalNavItemUrlArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** Individual link in the global nav. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/globalNavItem) */
export type GlobalNavItemAnalyticsArgsType = {
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<AnalyticsFilterType>;
};


/** Individual link in the global nav. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/globalNavItem) */
export type GlobalNavItemHideHostnameRegexArgsType = {
  locale: InputMaybe<Scalars['String']>;
};

export type GlobalNavItemLinkingCollectionsType = {
  readonly __typename?: 'GlobalNavItemLinkingCollections';
  readonly entryCollection: Maybe<EntryCollectionType>;
  readonly globalNavCollection: Maybe<GlobalNavCollectionType>;
};


export type GlobalNavItemLinkingCollectionsEntryCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type GlobalNavItemLinkingCollectionsGlobalNavCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<ReadonlyArray<InputMaybe<GlobalNavItemLinkingCollectionsGlobalNavCollectionOrderType>>>;
};

export type GlobalNavCollectionType = {
  readonly __typename?: 'GlobalNavCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<GlobalNavType>>;
};

/** Link group in the global navigation. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/globalNav) */
export type GlobalNavType = EntryType & _NodeType & {
  readonly __typename?: 'GlobalNav';
  readonly sys: SysType;
  readonly contentfulMetadata: ContentfulMetadataType;
  readonly linkedFrom: Maybe<GlobalNavLinkingCollectionsType>;
  readonly _id: Scalars['ID'];
  readonly title: Maybe<Scalars['String']>;
  readonly groupKey: Maybe<Scalars['String']>;
  readonly highlight: Maybe<GlobalNavHighlightType>;
  readonly itemsCollection: Maybe<GlobalNavItemsCollectionType>;
  readonly primaryHostnameRegex: Maybe<Scalars['String']>;
  readonly hideHostnameRegex: Maybe<Scalars['String']>;
};


/** Link group in the global navigation. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/globalNav) */
export type GlobalNavLinkedFromArgsType = {
  allowedLocales: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


/** Link group in the global navigation. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/globalNav) */
export type GlobalNavTitleArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** Link group in the global navigation. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/globalNav) */
export type GlobalNavGroupKeyArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** Link group in the global navigation. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/globalNav) */
export type GlobalNavHighlightArgsType = {
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<GlobalNavHighlightFilterType>;
};


/** Link group in the global navigation. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/globalNav) */
export type GlobalNavItemsCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<GlobalNavItemFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<GlobalNavItemsCollectionOrderType>>>;
};


/** Link group in the global navigation. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/globalNav) */
export type GlobalNavPrimaryHostnameRegexArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** Link group in the global navigation. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/globalNav) */
export type GlobalNavHideHostnameRegexArgsType = {
  locale: InputMaybe<Scalars['String']>;
};

export type GlobalNavLinkingCollectionsType = {
  readonly __typename?: 'GlobalNavLinkingCollections';
  readonly entryCollection: Maybe<EntryCollectionType>;
  readonly globalNavConfigCollection: Maybe<GlobalNavConfigCollectionType>;
};


export type GlobalNavLinkingCollectionsEntryCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type GlobalNavLinkingCollectionsGlobalNavConfigCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<ReadonlyArray<InputMaybe<GlobalNavLinkingCollectionsGlobalNavConfigCollectionOrderType>>>;
};

export type GlobalNavConfigCollectionType = {
  readonly __typename?: 'GlobalNavConfigCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<GlobalNavConfigType>>;
};

/** Configuration for the global navigation. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/globalNavConfig) */
export type GlobalNavConfigType = EntryType & _NodeType & {
  readonly __typename?: 'GlobalNavConfig';
  readonly sys: SysType;
  readonly contentfulMetadata: ContentfulMetadataType;
  readonly linkedFrom: Maybe<GlobalNavConfigLinkingCollectionsType>;
  readonly _id: Scalars['ID'];
  readonly title: Maybe<Scalars['String']>;
  readonly globalNavGroupsCollection: Maybe<GlobalNavConfigGlobalNavGroupsCollectionType>;
  readonly globalNavLabel: Maybe<Scalars['String']>;
  readonly globalNavButtonAriaLabel: Maybe<Scalars['String']>;
};


/** Configuration for the global navigation. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/globalNavConfig) */
export type GlobalNavConfigLinkedFromArgsType = {
  allowedLocales: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


/** Configuration for the global navigation. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/globalNavConfig) */
export type GlobalNavConfigTitleArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** Configuration for the global navigation. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/globalNavConfig) */
export type GlobalNavConfigGlobalNavGroupsCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<GlobalNavFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<GlobalNavConfigGlobalNavGroupsCollectionOrderType>>>;
};


/** Configuration for the global navigation. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/globalNavConfig) */
export type GlobalNavConfigGlobalNavLabelArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** Configuration for the global navigation. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/globalNavConfig) */
export type GlobalNavConfigGlobalNavButtonAriaLabelArgsType = {
  locale: InputMaybe<Scalars['String']>;
};

export type GlobalNavConfigLinkingCollectionsType = {
  readonly __typename?: 'GlobalNavConfigLinkingCollections';
  readonly entryCollection: Maybe<EntryCollectionType>;
};


export type GlobalNavConfigLinkingCollectionsEntryCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};

export type GlobalNavConfigGlobalNavGroupsCollectionType = {
  readonly __typename?: 'GlobalNavConfigGlobalNavGroupsCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<GlobalNavType>>;
};

export type GlobalNavFilterType = {
  readonly highlight: InputMaybe<CfGlobalNavHighlightNestedFilterType>;
  readonly items: InputMaybe<CfGlobalNavItemNestedFilterType>;
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly title_exists: InputMaybe<Scalars['Boolean']>;
  readonly title: InputMaybe<Scalars['String']>;
  readonly title_not: InputMaybe<Scalars['String']>;
  readonly title_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_contains: InputMaybe<Scalars['String']>;
  readonly title_not_contains: InputMaybe<Scalars['String']>;
  readonly groupKey_exists: InputMaybe<Scalars['Boolean']>;
  readonly groupKey: InputMaybe<Scalars['String']>;
  readonly groupKey_not: InputMaybe<Scalars['String']>;
  readonly groupKey_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly groupKey_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly groupKey_contains: InputMaybe<Scalars['String']>;
  readonly groupKey_not_contains: InputMaybe<Scalars['String']>;
  readonly highlight_exists: InputMaybe<Scalars['Boolean']>;
  readonly itemsCollection_exists: InputMaybe<Scalars['Boolean']>;
  readonly primaryHostnameRegex_exists: InputMaybe<Scalars['Boolean']>;
  readonly primaryHostnameRegex: InputMaybe<Scalars['String']>;
  readonly primaryHostnameRegex_not: InputMaybe<Scalars['String']>;
  readonly primaryHostnameRegex_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly primaryHostnameRegex_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly primaryHostnameRegex_contains: InputMaybe<Scalars['String']>;
  readonly primaryHostnameRegex_not_contains: InputMaybe<Scalars['String']>;
  readonly hideHostnameRegex_exists: InputMaybe<Scalars['Boolean']>;
  readonly hideHostnameRegex: InputMaybe<Scalars['String']>;
  readonly hideHostnameRegex_not: InputMaybe<Scalars['String']>;
  readonly hideHostnameRegex_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly hideHostnameRegex_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly hideHostnameRegex_contains: InputMaybe<Scalars['String']>;
  readonly hideHostnameRegex_not_contains: InputMaybe<Scalars['String']>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<GlobalNavFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<GlobalNavFilterType>>>;
};

export type CfGlobalNavHighlightNestedFilterType = {
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly title_exists: InputMaybe<Scalars['Boolean']>;
  readonly title: InputMaybe<Scalars['String']>;
  readonly title_not: InputMaybe<Scalars['String']>;
  readonly title_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_contains: InputMaybe<Scalars['String']>;
  readonly title_not_contains: InputMaybe<Scalars['String']>;
  readonly cta_exists: InputMaybe<Scalars['Boolean']>;
  readonly background_exists: InputMaybe<Scalars['Boolean']>;
  readonly cardTitleV2_exists: InputMaybe<Scalars['Boolean']>;
  readonly cardTitleV2: InputMaybe<Scalars['String']>;
  readonly cardTitleV2_not: InputMaybe<Scalars['String']>;
  readonly cardTitleV2_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly cardTitleV2_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly cardTitleV2_contains: InputMaybe<Scalars['String']>;
  readonly cardTitleV2_not_contains: InputMaybe<Scalars['String']>;
  readonly cardBodyV2_exists: InputMaybe<Scalars['Boolean']>;
  readonly cardBodyV2: InputMaybe<Scalars['String']>;
  readonly cardBodyV2_not: InputMaybe<Scalars['String']>;
  readonly cardBodyV2_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly cardBodyV2_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly cardBodyV2_contains: InputMaybe<Scalars['String']>;
  readonly cardBodyV2_not_contains: InputMaybe<Scalars['String']>;
  readonly cardContent_exists: InputMaybe<Scalars['Boolean']>;
  readonly cardContent_contains: InputMaybe<Scalars['String']>;
  readonly cardContent_not_contains: InputMaybe<Scalars['String']>;
  readonly cardTitle_exists: InputMaybe<Scalars['Boolean']>;
  readonly cardTitle_contains: InputMaybe<Scalars['String']>;
  readonly cardTitle_not_contains: InputMaybe<Scalars['String']>;
  readonly cardBody_exists: InputMaybe<Scalars['Boolean']>;
  readonly cardBody_contains: InputMaybe<Scalars['String']>;
  readonly cardBody_not_contains: InputMaybe<Scalars['String']>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<CfGlobalNavHighlightNestedFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<CfGlobalNavHighlightNestedFilterType>>>;
};

export type CfGlobalNavItemNestedFilterType = {
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly title_exists: InputMaybe<Scalars['Boolean']>;
  readonly title: InputMaybe<Scalars['String']>;
  readonly title_not: InputMaybe<Scalars['String']>;
  readonly title_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_contains: InputMaybe<Scalars['String']>;
  readonly title_not_contains: InputMaybe<Scalars['String']>;
  readonly url_exists: InputMaybe<Scalars['Boolean']>;
  readonly url: InputMaybe<Scalars['String']>;
  readonly url_not: InputMaybe<Scalars['String']>;
  readonly url_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly url_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly url_contains: InputMaybe<Scalars['String']>;
  readonly url_not_contains: InputMaybe<Scalars['String']>;
  readonly analytics_exists: InputMaybe<Scalars['Boolean']>;
  readonly hideHostnameRegex_exists: InputMaybe<Scalars['Boolean']>;
  readonly hideHostnameRegex: InputMaybe<Scalars['String']>;
  readonly hideHostnameRegex_not: InputMaybe<Scalars['String']>;
  readonly hideHostnameRegex_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly hideHostnameRegex_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly hideHostnameRegex_contains: InputMaybe<Scalars['String']>;
  readonly hideHostnameRegex_not_contains: InputMaybe<Scalars['String']>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<CfGlobalNavItemNestedFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<CfGlobalNavItemNestedFilterType>>>;
};

export enum GlobalNavConfigGlobalNavGroupsCollectionOrderType {
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  GroupKeyAscType = 'groupKey_ASC',
  GroupKeyDescType = 'groupKey_DESC',
  PrimaryHostnameRegexAscType = 'primaryHostnameRegex_ASC',
  PrimaryHostnameRegexDescType = 'primaryHostnameRegex_DESC',
  HideHostnameRegexAscType = 'hideHostnameRegex_ASC',
  HideHostnameRegexDescType = 'hideHostnameRegex_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export enum GlobalNavLinkingCollectionsGlobalNavConfigCollectionOrderType {
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  GlobalNavLabelAscType = 'globalNavLabel_ASC',
  GlobalNavLabelDescType = 'globalNavLabel_DESC',
  GlobalNavButtonAriaLabelAscType = 'globalNavButtonAriaLabel_ASC',
  GlobalNavButtonAriaLabelDescType = 'globalNavButtonAriaLabel_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

/** The highlight for a group of links. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/globalNavHighlight) */
export type GlobalNavHighlightType = EntryType & _NodeType & {
  readonly __typename?: 'GlobalNavHighlight';
  readonly sys: SysType;
  readonly contentfulMetadata: ContentfulMetadataType;
  readonly linkedFrom: Maybe<GlobalNavHighlightLinkingCollectionsType>;
  readonly _id: Scalars['ID'];
  readonly title: Maybe<Scalars['String']>;
  readonly cta: Maybe<CallToActionType>;
  readonly background: Maybe<AssetType>;
  readonly cardTitleV2: Maybe<Scalars['String']>;
  readonly cardBodyV2: Maybe<Scalars['String']>;
  readonly cardContent: Maybe<GlobalNavHighlightCardContentType>;
  readonly cardTitle: Maybe<GlobalNavHighlightCardTitleType>;
  readonly cardBody: Maybe<GlobalNavHighlightCardBodyType>;
};


/** The highlight for a group of links. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/globalNavHighlight) */
export type GlobalNavHighlightLinkedFromArgsType = {
  allowedLocales: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


/** The highlight for a group of links. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/globalNavHighlight) */
export type GlobalNavHighlightTitleArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** The highlight for a group of links. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/globalNavHighlight) */
export type GlobalNavHighlightCtaArgsType = {
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<CallToActionFilterType>;
};


/** The highlight for a group of links. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/globalNavHighlight) */
export type GlobalNavHighlightBackgroundArgsType = {
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


/** The highlight for a group of links. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/globalNavHighlight) */
export type GlobalNavHighlightCardTitleV2ArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** The highlight for a group of links. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/globalNavHighlight) */
export type GlobalNavHighlightCardBodyV2ArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** The highlight for a group of links. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/globalNavHighlight) */
export type GlobalNavHighlightCardContentArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** The highlight for a group of links. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/globalNavHighlight) */
export type GlobalNavHighlightCardTitleArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** The highlight for a group of links. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/globalNavHighlight) */
export type GlobalNavHighlightCardBodyArgsType = {
  locale: InputMaybe<Scalars['String']>;
};

export type GlobalNavHighlightLinkingCollectionsType = {
  readonly __typename?: 'GlobalNavHighlightLinkingCollections';
  readonly entryCollection: Maybe<EntryCollectionType>;
  readonly globalNavCollection: Maybe<GlobalNavCollectionType>;
};


export type GlobalNavHighlightLinkingCollectionsEntryCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type GlobalNavHighlightLinkingCollectionsGlobalNavCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<ReadonlyArray<InputMaybe<GlobalNavHighlightLinkingCollectionsGlobalNavCollectionOrderType>>>;
};

export enum GlobalNavHighlightLinkingCollectionsGlobalNavCollectionOrderType {
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  GroupKeyAscType = 'groupKey_ASC',
  GroupKeyDescType = 'groupKey_DESC',
  PrimaryHostnameRegexAscType = 'primaryHostnameRegex_ASC',
  PrimaryHostnameRegexDescType = 'primaryHostnameRegex_DESC',
  HideHostnameRegexAscType = 'hideHostnameRegex_ASC',
  HideHostnameRegexDescType = 'hideHostnameRegex_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/callToAction) */
export type CallToActionType = EntryType & _NodeType & {
  readonly __typename?: 'CallToAction';
  readonly sys: SysType;
  readonly contentfulMetadata: ContentfulMetadataType;
  readonly linkedFrom: Maybe<CallToActionLinkingCollectionsType>;
  readonly _id: Scalars['ID'];
  readonly contentfulDescription: Maybe<Scalars['String']>;
  readonly presentation: Maybe<CallToActionPresentationType>;
  readonly analytics: Maybe<AnalyticsType>;
  readonly url: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/callToAction) */
export type CallToActionLinkedFromArgsType = {
  allowedLocales: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/callToAction) */
export type CallToActionContentfulDescriptionArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/callToAction) */
export type CallToActionPresentationArgsType = {
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/callToAction) */
export type CallToActionAnalyticsArgsType = {
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<AnalyticsFilterType>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/callToAction) */
export type CallToActionUrlArgsType = {
  locale: InputMaybe<Scalars['String']>;
};

export type CallToActionLinkingCollectionsType = {
  readonly __typename?: 'CallToActionLinkingCollections';
  readonly entryCollection: Maybe<EntryCollectionType>;
  readonly globalNavHighlightCollection: Maybe<GlobalNavHighlightCollectionType>;
};


export type CallToActionLinkingCollectionsEntryCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type CallToActionLinkingCollectionsGlobalNavHighlightCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<ReadonlyArray<InputMaybe<CallToActionLinkingCollectionsGlobalNavHighlightCollectionOrderType>>>;
};

export type GlobalNavHighlightCollectionType = {
  readonly __typename?: 'GlobalNavHighlightCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<GlobalNavHighlightType>>;
};

export enum CallToActionLinkingCollectionsGlobalNavHighlightCollectionOrderType {
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  CardTitleV2AscType = 'cardTitleV2_ASC',
  CardTitleV2DescType = 'cardTitleV2_DESC',
  CardBodyV2AscType = 'cardBodyV2_ASC',
  CardBodyV2DescType = 'cardBodyV2_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export type CallToActionPresentationType = ButtonType;

/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/button) */
export type ButtonType = EntryType & _NodeType & {
  readonly __typename?: 'Button';
  readonly sys: SysType;
  readonly contentfulMetadata: ContentfulMetadataType;
  readonly linkedFrom: Maybe<ButtonLinkingCollectionsType>;
  readonly _id: Scalars['ID'];
  readonly contentfulDescription: Maybe<Scalars['String']>;
  readonly title: Maybe<ButtonTitleType>;
  readonly url: Maybe<Scalars['String']>;
  readonly size: Maybe<Scalars['String']>;
  readonly theme: Maybe<Scalars['String']>;
  readonly buttonType: Maybe<Scalars['String']>;
  readonly image: Maybe<ImageType>;
  readonly iconName: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/button) */
export type ButtonLinkedFromArgsType = {
  allowedLocales: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/button) */
export type ButtonContentfulDescriptionArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/button) */
export type ButtonTitleArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/button) */
export type ButtonUrlArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/button) */
export type ButtonSizeArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/button) */
export type ButtonThemeArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/button) */
export type ButtonButtonTypeArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/button) */
export type ButtonImageArgsType = {
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<ImageFilterType>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/button) */
export type ButtonIconNameArgsType = {
  locale: InputMaybe<Scalars['String']>;
};

export type ButtonLinkingCollectionsType = {
  readonly __typename?: 'ButtonLinkingCollections';
  readonly entryCollection: Maybe<EntryCollectionType>;
  readonly callToActionCollection: Maybe<CallToActionCollectionType>;
};


export type ButtonLinkingCollectionsEntryCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type ButtonLinkingCollectionsCallToActionCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<ReadonlyArray<InputMaybe<ButtonLinkingCollectionsCallToActionCollectionOrderType>>>;
};

export type CallToActionCollectionType = {
  readonly __typename?: 'CallToActionCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<CallToActionType>>;
};

export enum ButtonLinkingCollectionsCallToActionCollectionOrderType {
  ContentfulDescriptionAscType = 'contentfulDescription_ASC',
  ContentfulDescriptionDescType = 'contentfulDescription_DESC',
  UrlAscType = 'url_ASC',
  UrlDescType = 'url_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export type ButtonTitleType = {
  readonly __typename?: 'ButtonTitle';
  readonly json: Scalars['JSON'];
  readonly links: ButtonTitleLinksType;
};

export type ButtonTitleLinksType = {
  readonly __typename?: 'ButtonTitleLinks';
  readonly entries: ButtonTitleEntriesType;
  readonly assets: ButtonTitleAssetsType;
  readonly resources: ButtonTitleResourcesType;
};

export type ButtonTitleEntriesType = {
  readonly __typename?: 'ButtonTitleEntries';
  readonly inline: ReadonlyArray<Maybe<EntryType>>;
  readonly hyperlink: ReadonlyArray<Maybe<EntryType>>;
  readonly block: ReadonlyArray<Maybe<EntryType>>;
};

export type ButtonTitleAssetsType = {
  readonly __typename?: 'ButtonTitleAssets';
  readonly hyperlink: ReadonlyArray<Maybe<AssetType>>;
  readonly block: ReadonlyArray<Maybe<AssetType>>;
};

export type ButtonTitleResourcesType = {
  readonly __typename?: 'ButtonTitleResources';
  readonly block: ReadonlyArray<ButtonTitleResourcesBlockType>;
  readonly inline: ReadonlyArray<ButtonTitleResourcesInlineType>;
  readonly hyperlink: ReadonlyArray<ButtonTitleResourcesHyperlinkType>;
};

export type ButtonTitleResourcesBlockType = ResourceLinkType & {
  readonly __typename?: 'ButtonTitleResourcesBlock';
  readonly sys: ResourceSysType;
};

export type ResourceLinkType = {
  readonly sys: ResourceSysType;
};

export type ResourceSysType = {
  readonly __typename?: 'ResourceSys';
  readonly urn: Scalars['String'];
  readonly linkType: Scalars['String'];
};

export type ButtonTitleResourcesInlineType = ResourceLinkType & {
  readonly __typename?: 'ButtonTitleResourcesInline';
  readonly sys: ResourceSysType;
};

export type ButtonTitleResourcesHyperlinkType = ResourceLinkType & {
  readonly __typename?: 'ButtonTitleResourcesHyperlink';
  readonly sys: ResourceSysType;
};

export type ImageFilterType = {
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly contentfulDescription_exists: InputMaybe<Scalars['Boolean']>;
  readonly contentfulDescription: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_not: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentfulDescription_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentfulDescription_contains: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_not_contains: InputMaybe<Scalars['String']>;
  readonly media_exists: InputMaybe<Scalars['Boolean']>;
  readonly wrap_exists: InputMaybe<Scalars['Boolean']>;
  readonly wrap: InputMaybe<Scalars['String']>;
  readonly wrap_not: InputMaybe<Scalars['String']>;
  readonly wrap_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly wrap_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly wrap_contains: InputMaybe<Scalars['String']>;
  readonly wrap_not_contains: InputMaybe<Scalars['String']>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<ImageFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<ImageFilterType>>>;
};

export type CallToActionFilterType = {
  readonly analytics: InputMaybe<CfAnalyticsNestedFilterType>;
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly contentfulDescription_exists: InputMaybe<Scalars['Boolean']>;
  readonly contentfulDescription: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_not: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentfulDescription_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentfulDescription_contains: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_not_contains: InputMaybe<Scalars['String']>;
  readonly presentation_exists: InputMaybe<Scalars['Boolean']>;
  readonly analytics_exists: InputMaybe<Scalars['Boolean']>;
  readonly url_exists: InputMaybe<Scalars['Boolean']>;
  readonly url: InputMaybe<Scalars['String']>;
  readonly url_not: InputMaybe<Scalars['String']>;
  readonly url_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly url_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly url_contains: InputMaybe<Scalars['String']>;
  readonly url_not_contains: InputMaybe<Scalars['String']>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<CallToActionFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<CallToActionFilterType>>>;
};

export type CfAnalyticsNestedFilterType = {
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly label_exists: InputMaybe<Scalars['Boolean']>;
  readonly label: InputMaybe<Scalars['String']>;
  readonly label_not: InputMaybe<Scalars['String']>;
  readonly label_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly label_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly label_contains: InputMaybe<Scalars['String']>;
  readonly label_not_contains: InputMaybe<Scalars['String']>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<CfAnalyticsNestedFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<CfAnalyticsNestedFilterType>>>;
};

export type GlobalNavHighlightCardContentType = {
  readonly __typename?: 'GlobalNavHighlightCardContent';
  readonly json: Scalars['JSON'];
  readonly links: GlobalNavHighlightCardContentLinksType;
};

export type GlobalNavHighlightCardContentLinksType = {
  readonly __typename?: 'GlobalNavHighlightCardContentLinks';
  readonly entries: GlobalNavHighlightCardContentEntriesType;
  readonly assets: GlobalNavHighlightCardContentAssetsType;
  readonly resources: GlobalNavHighlightCardContentResourcesType;
};

export type GlobalNavHighlightCardContentEntriesType = {
  readonly __typename?: 'GlobalNavHighlightCardContentEntries';
  readonly inline: ReadonlyArray<Maybe<EntryType>>;
  readonly hyperlink: ReadonlyArray<Maybe<EntryType>>;
  readonly block: ReadonlyArray<Maybe<EntryType>>;
};

export type GlobalNavHighlightCardContentAssetsType = {
  readonly __typename?: 'GlobalNavHighlightCardContentAssets';
  readonly hyperlink: ReadonlyArray<Maybe<AssetType>>;
  readonly block: ReadonlyArray<Maybe<AssetType>>;
};

export type GlobalNavHighlightCardContentResourcesType = {
  readonly __typename?: 'GlobalNavHighlightCardContentResources';
  readonly block: ReadonlyArray<GlobalNavHighlightCardContentResourcesBlockType>;
  readonly inline: ReadonlyArray<GlobalNavHighlightCardContentResourcesInlineType>;
  readonly hyperlink: ReadonlyArray<GlobalNavHighlightCardContentResourcesHyperlinkType>;
};

export type GlobalNavHighlightCardContentResourcesBlockType = ResourceLinkType & {
  readonly __typename?: 'GlobalNavHighlightCardContentResourcesBlock';
  readonly sys: ResourceSysType;
};

export type GlobalNavHighlightCardContentResourcesInlineType = ResourceLinkType & {
  readonly __typename?: 'GlobalNavHighlightCardContentResourcesInline';
  readonly sys: ResourceSysType;
};

export type GlobalNavHighlightCardContentResourcesHyperlinkType = ResourceLinkType & {
  readonly __typename?: 'GlobalNavHighlightCardContentResourcesHyperlink';
  readonly sys: ResourceSysType;
};

export type GlobalNavHighlightCardTitleType = {
  readonly __typename?: 'GlobalNavHighlightCardTitle';
  readonly json: Scalars['JSON'];
  readonly links: GlobalNavHighlightCardTitleLinksType;
};

export type GlobalNavHighlightCardTitleLinksType = {
  readonly __typename?: 'GlobalNavHighlightCardTitleLinks';
  readonly entries: GlobalNavHighlightCardTitleEntriesType;
  readonly assets: GlobalNavHighlightCardTitleAssetsType;
  readonly resources: GlobalNavHighlightCardTitleResourcesType;
};

export type GlobalNavHighlightCardTitleEntriesType = {
  readonly __typename?: 'GlobalNavHighlightCardTitleEntries';
  readonly inline: ReadonlyArray<Maybe<EntryType>>;
  readonly hyperlink: ReadonlyArray<Maybe<EntryType>>;
  readonly block: ReadonlyArray<Maybe<EntryType>>;
};

export type GlobalNavHighlightCardTitleAssetsType = {
  readonly __typename?: 'GlobalNavHighlightCardTitleAssets';
  readonly hyperlink: ReadonlyArray<Maybe<AssetType>>;
  readonly block: ReadonlyArray<Maybe<AssetType>>;
};

export type GlobalNavHighlightCardTitleResourcesType = {
  readonly __typename?: 'GlobalNavHighlightCardTitleResources';
  readonly block: ReadonlyArray<GlobalNavHighlightCardTitleResourcesBlockType>;
  readonly inline: ReadonlyArray<GlobalNavHighlightCardTitleResourcesInlineType>;
  readonly hyperlink: ReadonlyArray<GlobalNavHighlightCardTitleResourcesHyperlinkType>;
};

export type GlobalNavHighlightCardTitleResourcesBlockType = ResourceLinkType & {
  readonly __typename?: 'GlobalNavHighlightCardTitleResourcesBlock';
  readonly sys: ResourceSysType;
};

export type GlobalNavHighlightCardTitleResourcesInlineType = ResourceLinkType & {
  readonly __typename?: 'GlobalNavHighlightCardTitleResourcesInline';
  readonly sys: ResourceSysType;
};

export type GlobalNavHighlightCardTitleResourcesHyperlinkType = ResourceLinkType & {
  readonly __typename?: 'GlobalNavHighlightCardTitleResourcesHyperlink';
  readonly sys: ResourceSysType;
};

export type GlobalNavHighlightCardBodyType = {
  readonly __typename?: 'GlobalNavHighlightCardBody';
  readonly json: Scalars['JSON'];
  readonly links: GlobalNavHighlightCardBodyLinksType;
};

export type GlobalNavHighlightCardBodyLinksType = {
  readonly __typename?: 'GlobalNavHighlightCardBodyLinks';
  readonly entries: GlobalNavHighlightCardBodyEntriesType;
  readonly assets: GlobalNavHighlightCardBodyAssetsType;
  readonly resources: GlobalNavHighlightCardBodyResourcesType;
};

export type GlobalNavHighlightCardBodyEntriesType = {
  readonly __typename?: 'GlobalNavHighlightCardBodyEntries';
  readonly inline: ReadonlyArray<Maybe<EntryType>>;
  readonly hyperlink: ReadonlyArray<Maybe<EntryType>>;
  readonly block: ReadonlyArray<Maybe<EntryType>>;
};

export type GlobalNavHighlightCardBodyAssetsType = {
  readonly __typename?: 'GlobalNavHighlightCardBodyAssets';
  readonly hyperlink: ReadonlyArray<Maybe<AssetType>>;
  readonly block: ReadonlyArray<Maybe<AssetType>>;
};

export type GlobalNavHighlightCardBodyResourcesType = {
  readonly __typename?: 'GlobalNavHighlightCardBodyResources';
  readonly block: ReadonlyArray<GlobalNavHighlightCardBodyResourcesBlockType>;
  readonly inline: ReadonlyArray<GlobalNavHighlightCardBodyResourcesInlineType>;
  readonly hyperlink: ReadonlyArray<GlobalNavHighlightCardBodyResourcesHyperlinkType>;
};

export type GlobalNavHighlightCardBodyResourcesBlockType = ResourceLinkType & {
  readonly __typename?: 'GlobalNavHighlightCardBodyResourcesBlock';
  readonly sys: ResourceSysType;
};

export type GlobalNavHighlightCardBodyResourcesInlineType = ResourceLinkType & {
  readonly __typename?: 'GlobalNavHighlightCardBodyResourcesInline';
  readonly sys: ResourceSysType;
};

export type GlobalNavHighlightCardBodyResourcesHyperlinkType = ResourceLinkType & {
  readonly __typename?: 'GlobalNavHighlightCardBodyResourcesHyperlink';
  readonly sys: ResourceSysType;
};

export type GlobalNavHighlightFilterType = {
  readonly cta: InputMaybe<CfCallToActionNestedFilterType>;
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly title_exists: InputMaybe<Scalars['Boolean']>;
  readonly title: InputMaybe<Scalars['String']>;
  readonly title_not: InputMaybe<Scalars['String']>;
  readonly title_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_contains: InputMaybe<Scalars['String']>;
  readonly title_not_contains: InputMaybe<Scalars['String']>;
  readonly cta_exists: InputMaybe<Scalars['Boolean']>;
  readonly background_exists: InputMaybe<Scalars['Boolean']>;
  readonly cardTitleV2_exists: InputMaybe<Scalars['Boolean']>;
  readonly cardTitleV2: InputMaybe<Scalars['String']>;
  readonly cardTitleV2_not: InputMaybe<Scalars['String']>;
  readonly cardTitleV2_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly cardTitleV2_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly cardTitleV2_contains: InputMaybe<Scalars['String']>;
  readonly cardTitleV2_not_contains: InputMaybe<Scalars['String']>;
  readonly cardBodyV2_exists: InputMaybe<Scalars['Boolean']>;
  readonly cardBodyV2: InputMaybe<Scalars['String']>;
  readonly cardBodyV2_not: InputMaybe<Scalars['String']>;
  readonly cardBodyV2_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly cardBodyV2_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly cardBodyV2_contains: InputMaybe<Scalars['String']>;
  readonly cardBodyV2_not_contains: InputMaybe<Scalars['String']>;
  readonly cardContent_exists: InputMaybe<Scalars['Boolean']>;
  readonly cardContent_contains: InputMaybe<Scalars['String']>;
  readonly cardContent_not_contains: InputMaybe<Scalars['String']>;
  readonly cardTitle_exists: InputMaybe<Scalars['Boolean']>;
  readonly cardTitle_contains: InputMaybe<Scalars['String']>;
  readonly cardTitle_not_contains: InputMaybe<Scalars['String']>;
  readonly cardBody_exists: InputMaybe<Scalars['Boolean']>;
  readonly cardBody_contains: InputMaybe<Scalars['String']>;
  readonly cardBody_not_contains: InputMaybe<Scalars['String']>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<GlobalNavHighlightFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<GlobalNavHighlightFilterType>>>;
};

export type CfCallToActionNestedFilterType = {
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly contentfulDescription_exists: InputMaybe<Scalars['Boolean']>;
  readonly contentfulDescription: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_not: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentfulDescription_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentfulDescription_contains: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_not_contains: InputMaybe<Scalars['String']>;
  readonly presentation_exists: InputMaybe<Scalars['Boolean']>;
  readonly analytics_exists: InputMaybe<Scalars['Boolean']>;
  readonly url_exists: InputMaybe<Scalars['Boolean']>;
  readonly url: InputMaybe<Scalars['String']>;
  readonly url_not: InputMaybe<Scalars['String']>;
  readonly url_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly url_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly url_contains: InputMaybe<Scalars['String']>;
  readonly url_not_contains: InputMaybe<Scalars['String']>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<CfCallToActionNestedFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<CfCallToActionNestedFilterType>>>;
};

export type GlobalNavItemsCollectionType = {
  readonly __typename?: 'GlobalNavItemsCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<GlobalNavItemType>>;
};

export type GlobalNavItemFilterType = {
  readonly analytics: InputMaybe<CfAnalyticsNestedFilterType>;
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly title_exists: InputMaybe<Scalars['Boolean']>;
  readonly title: InputMaybe<Scalars['String']>;
  readonly title_not: InputMaybe<Scalars['String']>;
  readonly title_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_contains: InputMaybe<Scalars['String']>;
  readonly title_not_contains: InputMaybe<Scalars['String']>;
  readonly url_exists: InputMaybe<Scalars['Boolean']>;
  readonly url: InputMaybe<Scalars['String']>;
  readonly url_not: InputMaybe<Scalars['String']>;
  readonly url_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly url_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly url_contains: InputMaybe<Scalars['String']>;
  readonly url_not_contains: InputMaybe<Scalars['String']>;
  readonly analytics_exists: InputMaybe<Scalars['Boolean']>;
  readonly hideHostnameRegex_exists: InputMaybe<Scalars['Boolean']>;
  readonly hideHostnameRegex: InputMaybe<Scalars['String']>;
  readonly hideHostnameRegex_not: InputMaybe<Scalars['String']>;
  readonly hideHostnameRegex_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly hideHostnameRegex_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly hideHostnameRegex_contains: InputMaybe<Scalars['String']>;
  readonly hideHostnameRegex_not_contains: InputMaybe<Scalars['String']>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<GlobalNavItemFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<GlobalNavItemFilterType>>>;
};

export enum GlobalNavItemsCollectionOrderType {
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  UrlAscType = 'url_ASC',
  UrlDescType = 'url_DESC',
  HideHostnameRegexAscType = 'hideHostnameRegex_ASC',
  HideHostnameRegexDescType = 'hideHostnameRegex_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export enum GlobalNavItemLinkingCollectionsGlobalNavCollectionOrderType {
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  GroupKeyAscType = 'groupKey_ASC',
  GroupKeyDescType = 'groupKey_DESC',
  PrimaryHostnameRegexAscType = 'primaryHostnameRegex_ASC',
  PrimaryHostnameRegexDescType = 'primaryHostnameRegex_DESC',
  HideHostnameRegexAscType = 'hideHostnameRegex_ASC',
  HideHostnameRegexDescType = 'hideHostnameRegex_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export enum AnalyticsLinkingCollectionsGlobalNavItemCollectionOrderType {
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  UrlAscType = 'url_ASC',
  UrlDescType = 'url_DESC',
  HideHostnameRegexAscType = 'hideHostnameRegex_ASC',
  HideHostnameRegexDescType = 'hideHostnameRegex_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export enum AnalyticsLinkingCollectionsCallToActionCollectionOrderType {
  ContentfulDescriptionAscType = 'contentfulDescription_ASC',
  ContentfulDescriptionDescType = 'contentfulDescription_DESC',
  UrlAscType = 'url_ASC',
  UrlDescType = 'url_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export type FooterItemCollectionType = {
  readonly __typename?: 'FooterItemCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<FooterItemType>>;
};

/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerItem) */
export type FooterItemType = EntryType & _NodeType & {
  readonly __typename?: 'FooterItem';
  readonly sys: SysType;
  readonly contentfulMetadata: ContentfulMetadataType;
  readonly linkedFrom: Maybe<FooterItemLinkingCollectionsType>;
  readonly _id: Scalars['ID'];
  readonly title: Maybe<Scalars['String']>;
  readonly url: Maybe<Scalars['String']>;
  readonly analytics: Maybe<AnalyticsType>;
  readonly footerItemsCollection: Maybe<FooterItemFooterItemsCollectionType>;
  readonly globalOnly: Maybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerItem) */
export type FooterItemLinkedFromArgsType = {
  allowedLocales: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerItem) */
export type FooterItemTitleArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerItem) */
export type FooterItemUrlArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerItem) */
export type FooterItemAnalyticsArgsType = {
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<AnalyticsFilterType>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerItem) */
export type FooterItemFooterItemsCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<FooterItemFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<FooterItemFooterItemsCollectionOrderType>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerItem) */
export type FooterItemGlobalOnlyArgsType = {
  locale: InputMaybe<Scalars['String']>;
};

export type FooterItemLinkingCollectionsType = {
  readonly __typename?: 'FooterItemLinkingCollections';
  readonly entryCollection: Maybe<EntryCollectionType>;
  readonly footerCollection: Maybe<FooterCollectionType>;
  readonly footerItemCollection: Maybe<FooterItemCollectionType>;
};


export type FooterItemLinkingCollectionsEntryCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type FooterItemLinkingCollectionsFooterCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<ReadonlyArray<InputMaybe<FooterItemLinkingCollectionsFooterCollectionOrderType>>>;
};


export type FooterItemLinkingCollectionsFooterItemCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<ReadonlyArray<InputMaybe<FooterItemLinkingCollectionsFooterItemCollectionOrderType>>>;
};

export type FooterCollectionType = {
  readonly __typename?: 'FooterCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<FooterType>>;
};

/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footer) */
export type FooterType = EntryType & _NodeType & {
  readonly __typename?: 'Footer';
  readonly sys: SysType;
  readonly contentfulMetadata: ContentfulMetadataType;
  readonly linkedFrom: Maybe<FooterLinkingCollectionsType>;
  readonly _id: Scalars['ID'];
  readonly title: Maybe<Scalars['String']>;
  readonly footerColumnCollection: Maybe<FooterFooterColumnCollectionType>;
  readonly footerBarCollection: Maybe<FooterFooterBarCollectionType>;
  readonly globalOnly: Maybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footer) */
export type FooterLinkedFromArgsType = {
  allowedLocales: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footer) */
export type FooterTitleArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footer) */
export type FooterFooterColumnCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<FooterItemFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<FooterFooterColumnCollectionOrderType>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footer) */
export type FooterFooterBarCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<FooterItemFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<FooterFooterBarCollectionOrderType>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footer) */
export type FooterGlobalOnlyArgsType = {
  locale: InputMaybe<Scalars['String']>;
};

export type FooterLinkingCollectionsType = {
  readonly __typename?: 'FooterLinkingCollections';
  readonly entryCollection: Maybe<EntryCollectionType>;
};


export type FooterLinkingCollectionsEntryCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};

export type FooterFooterColumnCollectionType = {
  readonly __typename?: 'FooterFooterColumnCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<FooterItemType>>;
};

export type FooterItemFilterType = {
  readonly analytics: InputMaybe<CfAnalyticsNestedFilterType>;
  readonly footerItems: InputMaybe<CfFooterItemNestedFilterType>;
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly title_exists: InputMaybe<Scalars['Boolean']>;
  readonly title: InputMaybe<Scalars['String']>;
  readonly title_not: InputMaybe<Scalars['String']>;
  readonly title_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_contains: InputMaybe<Scalars['String']>;
  readonly title_not_contains: InputMaybe<Scalars['String']>;
  readonly url_exists: InputMaybe<Scalars['Boolean']>;
  readonly url: InputMaybe<Scalars['String']>;
  readonly url_not: InputMaybe<Scalars['String']>;
  readonly url_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly url_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly url_contains: InputMaybe<Scalars['String']>;
  readonly url_not_contains: InputMaybe<Scalars['String']>;
  readonly analytics_exists: InputMaybe<Scalars['Boolean']>;
  readonly footerItemsCollection_exists: InputMaybe<Scalars['Boolean']>;
  readonly globalOnly_exists: InputMaybe<Scalars['Boolean']>;
  readonly globalOnly: InputMaybe<Scalars['Boolean']>;
  readonly globalOnly_not: InputMaybe<Scalars['Boolean']>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<FooterItemFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<FooterItemFilterType>>>;
};

export type CfFooterItemNestedFilterType = {
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly title_exists: InputMaybe<Scalars['Boolean']>;
  readonly title: InputMaybe<Scalars['String']>;
  readonly title_not: InputMaybe<Scalars['String']>;
  readonly title_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_contains: InputMaybe<Scalars['String']>;
  readonly title_not_contains: InputMaybe<Scalars['String']>;
  readonly url_exists: InputMaybe<Scalars['Boolean']>;
  readonly url: InputMaybe<Scalars['String']>;
  readonly url_not: InputMaybe<Scalars['String']>;
  readonly url_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly url_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly url_contains: InputMaybe<Scalars['String']>;
  readonly url_not_contains: InputMaybe<Scalars['String']>;
  readonly analytics_exists: InputMaybe<Scalars['Boolean']>;
  readonly footerItemsCollection_exists: InputMaybe<Scalars['Boolean']>;
  readonly globalOnly_exists: InputMaybe<Scalars['Boolean']>;
  readonly globalOnly: InputMaybe<Scalars['Boolean']>;
  readonly globalOnly_not: InputMaybe<Scalars['Boolean']>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<CfFooterItemNestedFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<CfFooterItemNestedFilterType>>>;
};

export enum FooterFooterColumnCollectionOrderType {
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  UrlAscType = 'url_ASC',
  UrlDescType = 'url_DESC',
  GlobalOnlyAscType = 'globalOnly_ASC',
  GlobalOnlyDescType = 'globalOnly_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export type FooterFooterBarCollectionType = {
  readonly __typename?: 'FooterFooterBarCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<FooterItemType>>;
};

export enum FooterFooterBarCollectionOrderType {
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  UrlAscType = 'url_ASC',
  UrlDescType = 'url_DESC',
  GlobalOnlyAscType = 'globalOnly_ASC',
  GlobalOnlyDescType = 'globalOnly_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export enum FooterItemLinkingCollectionsFooterCollectionOrderType {
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  GlobalOnlyAscType = 'globalOnly_ASC',
  GlobalOnlyDescType = 'globalOnly_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export enum FooterItemLinkingCollectionsFooterItemCollectionOrderType {
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  UrlAscType = 'url_ASC',
  UrlDescType = 'url_DESC',
  GlobalOnlyAscType = 'globalOnly_ASC',
  GlobalOnlyDescType = 'globalOnly_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export type FooterItemFooterItemsCollectionType = {
  readonly __typename?: 'FooterItemFooterItemsCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<FooterItemType>>;
};

export enum FooterItemFooterItemsCollectionOrderType {
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  UrlAscType = 'url_ASC',
  UrlDescType = 'url_DESC',
  GlobalOnlyAscType = 'globalOnly_ASC',
  GlobalOnlyDescType = 'globalOnly_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export enum AnalyticsLinkingCollectionsFooterItemCollectionOrderType {
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  UrlAscType = 'url_ASC',
  UrlDescType = 'url_DESC',
  GlobalOnlyAscType = 'globalOnly_ASC',
  GlobalOnlyDescType = 'globalOnly_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

/** Footer Locale Dropdown model [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerLocaleDropdown) */
export type FooterLocaleDropdownType = EntryType & _NodeType & {
  readonly __typename?: 'FooterLocaleDropdown';
  readonly sys: SysType;
  readonly contentfulMetadata: ContentfulMetadataType;
  readonly linkedFrom: Maybe<FooterLocaleDropdownLinkingCollectionsType>;
  readonly _id: Scalars['ID'];
  readonly contentfulDescription: Maybe<Scalars['String']>;
  readonly title: Maybe<Scalars['String']>;
  readonly hideOnDomains: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
};


/** Footer Locale Dropdown model [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerLocaleDropdown) */
export type FooterLocaleDropdownLinkedFromArgsType = {
  allowedLocales: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


/** Footer Locale Dropdown model [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerLocaleDropdown) */
export type FooterLocaleDropdownContentfulDescriptionArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** Footer Locale Dropdown model [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerLocaleDropdown) */
export type FooterLocaleDropdownTitleArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** Footer Locale Dropdown model [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/footerLocaleDropdown) */
export type FooterLocaleDropdownHideOnDomainsArgsType = {
  locale: InputMaybe<Scalars['String']>;
};

export type FooterLocaleDropdownLinkingCollectionsType = {
  readonly __typename?: 'FooterLocaleDropdownLinkingCollections';
  readonly entryCollection: Maybe<EntryCollectionType>;
  readonly footerGroupCollection: Maybe<FooterGroupCollectionType>;
};


export type FooterLocaleDropdownLinkingCollectionsEntryCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type FooterLocaleDropdownLinkingCollectionsFooterGroupCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<ReadonlyArray<InputMaybe<FooterLocaleDropdownLinkingCollectionsFooterGroupCollectionOrderType>>>;
};

export enum FooterLocaleDropdownLinkingCollectionsFooterGroupCollectionOrderType {
  ContentfulDescriptionAscType = 'contentfulDescription_ASC',
  ContentfulDescriptionDescType = 'contentfulDescription_DESC',
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  GroupKeyAscType = 'groupKey_ASC',
  GroupKeyDescType = 'groupKey_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export type FooterGroupItemsFilterType = {
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly contentfulDescription_exists: InputMaybe<Scalars['Boolean']>;
  readonly contentfulDescription: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_not: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentfulDescription_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentfulDescription_contains: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_not_contains: InputMaybe<Scalars['String']>;
  readonly title_exists: InputMaybe<Scalars['Boolean']>;
  readonly title: InputMaybe<Scalars['String']>;
  readonly title_not: InputMaybe<Scalars['String']>;
  readonly title_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_contains: InputMaybe<Scalars['String']>;
  readonly title_not_contains: InputMaybe<Scalars['String']>;
  readonly hideOnDomains_exists: InputMaybe<Scalars['Boolean']>;
  readonly hideOnDomains_contains_all: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly hideOnDomains_contains_some: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly hideOnDomains_contains_none: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<FooterGroupItemsFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<FooterGroupItemsFilterType>>>;
};

export type FooterGroupFilterType = {
  readonly items: InputMaybe<CfitemsMultiTypeNestedFilterType>;
  readonly analytics: InputMaybe<CfAnalyticsNestedFilterType>;
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly contentfulDescription_exists: InputMaybe<Scalars['Boolean']>;
  readonly contentfulDescription: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_not: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentfulDescription_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentfulDescription_contains: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_not_contains: InputMaybe<Scalars['String']>;
  readonly title_exists: InputMaybe<Scalars['Boolean']>;
  readonly title: InputMaybe<Scalars['String']>;
  readonly title_not: InputMaybe<Scalars['String']>;
  readonly title_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_contains: InputMaybe<Scalars['String']>;
  readonly title_not_contains: InputMaybe<Scalars['String']>;
  readonly groupKey_exists: InputMaybe<Scalars['Boolean']>;
  readonly groupKey: InputMaybe<Scalars['String']>;
  readonly groupKey_not: InputMaybe<Scalars['String']>;
  readonly groupKey_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly groupKey_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly groupKey_contains: InputMaybe<Scalars['String']>;
  readonly groupKey_not_contains: InputMaybe<Scalars['String']>;
  readonly itemsCollection_exists: InputMaybe<Scalars['Boolean']>;
  readonly analytics_exists: InputMaybe<Scalars['Boolean']>;
  readonly hideOnDomains_exists: InputMaybe<Scalars['Boolean']>;
  readonly hideOnDomains_contains_all: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly hideOnDomains_contains_some: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly hideOnDomains_contains_none: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<FooterGroupFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<FooterGroupFilterType>>>;
};

export type CfitemsMultiTypeNestedFilterType = {
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly contentfulDescription_exists: InputMaybe<Scalars['Boolean']>;
  readonly contentfulDescription: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_not: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentfulDescription_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentfulDescription_contains: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_not_contains: InputMaybe<Scalars['String']>;
  readonly title_exists: InputMaybe<Scalars['Boolean']>;
  readonly title: InputMaybe<Scalars['String']>;
  readonly title_not: InputMaybe<Scalars['String']>;
  readonly title_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_contains: InputMaybe<Scalars['String']>;
  readonly title_not_contains: InputMaybe<Scalars['String']>;
  readonly hideOnDomains_exists: InputMaybe<Scalars['Boolean']>;
  readonly hideOnDomains_contains_all: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly hideOnDomains_contains_some: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly hideOnDomains_contains_none: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<CfitemsMultiTypeNestedFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<CfitemsMultiTypeNestedFilterType>>>;
};

export enum FooterV3ColumnsCollectionOrderType {
  ContentfulDescriptionAscType = 'contentfulDescription_ASC',
  ContentfulDescriptionDescType = 'contentfulDescription_DESC',
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  GroupKeyAscType = 'groupKey_ASC',
  GroupKeyDescType = 'groupKey_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export type FooterV3BarCollectionType = {
  readonly __typename?: 'FooterV3BarCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<FooterGroupType>>;
};

export enum FooterV3BarCollectionOrderType {
  ContentfulDescriptionAscType = 'contentfulDescription_ASC',
  ContentfulDescriptionDescType = 'contentfulDescription_DESC',
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  GroupKeyAscType = 'groupKey_ASC',
  GroupKeyDescType = 'groupKey_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export enum ImageLinkingCollectionsFooterV3CollectionOrderType {
  ContentfulDescriptionAscType = 'contentfulDescription_ASC',
  ContentfulDescriptionDescType = 'contentfulDescription_DESC',
  UrlAscType = 'url_ASC',
  UrlDescType = 'url_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export type ButtonCollectionType = {
  readonly __typename?: 'ButtonCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<ButtonType>>;
};

export enum ImageLinkingCollectionsButtonCollectionOrderType {
  ContentfulDescriptionAscType = 'contentfulDescription_ASC',
  ContentfulDescriptionDescType = 'contentfulDescription_DESC',
  UrlAscType = 'url_ASC',
  UrlDescType = 'url_DESC',
  SizeAscType = 'size_ASC',
  SizeDescType = 'size_DESC',
  ThemeAscType = 'theme_ASC',
  ThemeDescType = 'theme_DESC',
  ButtonTypeAscType = 'buttonType_ASC',
  ButtonTypeDescType = 'buttonType_DESC',
  IconNameAscType = 'iconName_ASC',
  IconNameDescType = 'iconName_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export type CookieBannerCollectionType = {
  readonly __typename?: 'CookieBannerCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<CookieBannerType>>;
};

/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieBanner) */
export type CookieBannerType = EntryType & _NodeType & {
  readonly __typename?: 'CookieBanner';
  readonly sys: SysType;
  readonly contentfulMetadata: ContentfulMetadataType;
  readonly linkedFrom: Maybe<CookieBannerLinkingCollectionsType>;
  readonly _id: Scalars['ID'];
  readonly title: Maybe<Scalars['String']>;
  readonly leftMedia: Maybe<AssetType>;
  readonly rightMedia: Maybe<AssetType>;
  readonly body: Maybe<CookieBannerBodyType>;
  readonly acceptCookiesButton: Maybe<Scalars['String']>;
  readonly cookieSettingsButtonText: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieBanner) */
export type CookieBannerLinkedFromArgsType = {
  allowedLocales: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieBanner) */
export type CookieBannerTitleArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieBanner) */
export type CookieBannerLeftMediaArgsType = {
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieBanner) */
export type CookieBannerRightMediaArgsType = {
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieBanner) */
export type CookieBannerBodyArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieBanner) */
export type CookieBannerAcceptCookiesButtonArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieBanner) */
export type CookieBannerCookieSettingsButtonTextArgsType = {
  locale: InputMaybe<Scalars['String']>;
};

export type CookieBannerLinkingCollectionsType = {
  readonly __typename?: 'CookieBannerLinkingCollections';
  readonly entryCollection: Maybe<EntryCollectionType>;
};


export type CookieBannerLinkingCollectionsEntryCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};

export type CookieBannerBodyType = {
  readonly __typename?: 'CookieBannerBody';
  readonly json: Scalars['JSON'];
  readonly links: CookieBannerBodyLinksType;
};

export type CookieBannerBodyLinksType = {
  readonly __typename?: 'CookieBannerBodyLinks';
  readonly entries: CookieBannerBodyEntriesType;
  readonly assets: CookieBannerBodyAssetsType;
  readonly resources: CookieBannerBodyResourcesType;
};

export type CookieBannerBodyEntriesType = {
  readonly __typename?: 'CookieBannerBodyEntries';
  readonly inline: ReadonlyArray<Maybe<EntryType>>;
  readonly hyperlink: ReadonlyArray<Maybe<EntryType>>;
  readonly block: ReadonlyArray<Maybe<EntryType>>;
};

export type CookieBannerBodyAssetsType = {
  readonly __typename?: 'CookieBannerBodyAssets';
  readonly hyperlink: ReadonlyArray<Maybe<AssetType>>;
  readonly block: ReadonlyArray<Maybe<AssetType>>;
};

export type CookieBannerBodyResourcesType = {
  readonly __typename?: 'CookieBannerBodyResources';
  readonly block: ReadonlyArray<CookieBannerBodyResourcesBlockType>;
  readonly inline: ReadonlyArray<CookieBannerBodyResourcesInlineType>;
  readonly hyperlink: ReadonlyArray<CookieBannerBodyResourcesHyperlinkType>;
};

export type CookieBannerBodyResourcesBlockType = ResourceLinkType & {
  readonly __typename?: 'CookieBannerBodyResourcesBlock';
  readonly sys: ResourceSysType;
};

export type CookieBannerBodyResourcesInlineType = ResourceLinkType & {
  readonly __typename?: 'CookieBannerBodyResourcesInline';
  readonly sys: ResourceSysType;
};

export type CookieBannerBodyResourcesHyperlinkType = ResourceLinkType & {
  readonly __typename?: 'CookieBannerBodyResourcesHyperlink';
  readonly sys: ResourceSysType;
};

export type VideoCollectionType = {
  readonly __typename?: 'VideoCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<VideoType>>;
};

/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/video) */
export type VideoType = EntryType & _NodeType & {
  readonly __typename?: 'Video';
  readonly sys: SysType;
  readonly contentfulMetadata: ContentfulMetadataType;
  readonly linkedFrom: Maybe<VideoLinkingCollectionsType>;
  readonly _id: Scalars['ID'];
  readonly contentfulDescription: Maybe<Scalars['String']>;
  readonly media: Maybe<AssetType>;
  readonly thumbnailMedia: Maybe<AssetType>;
  readonly autoPlay: Maybe<Scalars['Boolean']>;
  readonly wrap: Maybe<Scalars['String']>;
  readonly captions: Maybe<AssetType>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/video) */
export type VideoLinkedFromArgsType = {
  allowedLocales: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/video) */
export type VideoContentfulDescriptionArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/video) */
export type VideoMediaArgsType = {
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/video) */
export type VideoThumbnailMediaArgsType = {
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/video) */
export type VideoAutoPlayArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/video) */
export type VideoWrapArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/video) */
export type VideoCaptionsArgsType = {
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};

export type VideoLinkingCollectionsType = {
  readonly __typename?: 'VideoLinkingCollections';
  readonly entryCollection: Maybe<EntryCollectionType>;
};


export type VideoLinkingCollectionsEntryCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};

export type AssetCollectionType = {
  readonly __typename?: 'AssetCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<AssetType>>;
};

export type AssetFilterType = {
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly title_exists: InputMaybe<Scalars['Boolean']>;
  readonly title: InputMaybe<Scalars['String']>;
  readonly title_not: InputMaybe<Scalars['String']>;
  readonly title_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_contains: InputMaybe<Scalars['String']>;
  readonly title_not_contains: InputMaybe<Scalars['String']>;
  readonly description_exists: InputMaybe<Scalars['Boolean']>;
  readonly description: InputMaybe<Scalars['String']>;
  readonly description_not: InputMaybe<Scalars['String']>;
  readonly description_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly description_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly description_contains: InputMaybe<Scalars['String']>;
  readonly description_not_contains: InputMaybe<Scalars['String']>;
  readonly url_exists: InputMaybe<Scalars['Boolean']>;
  readonly url: InputMaybe<Scalars['String']>;
  readonly url_not: InputMaybe<Scalars['String']>;
  readonly url_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly url_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly url_contains: InputMaybe<Scalars['String']>;
  readonly url_not_contains: InputMaybe<Scalars['String']>;
  readonly size_exists: InputMaybe<Scalars['Boolean']>;
  readonly size: InputMaybe<Scalars['Int']>;
  readonly size_not: InputMaybe<Scalars['Int']>;
  readonly size_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Int']>>>;
  readonly size_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Int']>>>;
  readonly size_gt: InputMaybe<Scalars['Int']>;
  readonly size_gte: InputMaybe<Scalars['Int']>;
  readonly size_lt: InputMaybe<Scalars['Int']>;
  readonly size_lte: InputMaybe<Scalars['Int']>;
  readonly contentType_exists: InputMaybe<Scalars['Boolean']>;
  readonly contentType: InputMaybe<Scalars['String']>;
  readonly contentType_not: InputMaybe<Scalars['String']>;
  readonly contentType_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentType_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentType_contains: InputMaybe<Scalars['String']>;
  readonly contentType_not_contains: InputMaybe<Scalars['String']>;
  readonly fileName_exists: InputMaybe<Scalars['Boolean']>;
  readonly fileName: InputMaybe<Scalars['String']>;
  readonly fileName_not: InputMaybe<Scalars['String']>;
  readonly fileName_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly fileName_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly fileName_contains: InputMaybe<Scalars['String']>;
  readonly fileName_not_contains: InputMaybe<Scalars['String']>;
  readonly width_exists: InputMaybe<Scalars['Boolean']>;
  readonly width: InputMaybe<Scalars['Int']>;
  readonly width_not: InputMaybe<Scalars['Int']>;
  readonly width_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Int']>>>;
  readonly width_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Int']>>>;
  readonly width_gt: InputMaybe<Scalars['Int']>;
  readonly width_gte: InputMaybe<Scalars['Int']>;
  readonly width_lt: InputMaybe<Scalars['Int']>;
  readonly width_lte: InputMaybe<Scalars['Int']>;
  readonly height_exists: InputMaybe<Scalars['Boolean']>;
  readonly height: InputMaybe<Scalars['Int']>;
  readonly height_not: InputMaybe<Scalars['Int']>;
  readonly height_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Int']>>>;
  readonly height_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Int']>>>;
  readonly height_gt: InputMaybe<Scalars['Int']>;
  readonly height_gte: InputMaybe<Scalars['Int']>;
  readonly height_lt: InputMaybe<Scalars['Int']>;
  readonly height_lte: InputMaybe<Scalars['Int']>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<AssetFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<AssetFilterType>>>;
};

export enum AssetOrderType {
  UrlAscType = 'url_ASC',
  UrlDescType = 'url_DESC',
  SizeAscType = 'size_ASC',
  SizeDescType = 'size_DESC',
  ContentTypeAscType = 'contentType_ASC',
  ContentTypeDescType = 'contentType_DESC',
  FileNameAscType = 'fileName_ASC',
  FileNameDescType = 'fileName_DESC',
  WidthAscType = 'width_ASC',
  WidthDescType = 'width_DESC',
  HeightAscType = 'height_ASC',
  HeightDescType = 'height_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export type GlobalNavConfigFilterType = {
  readonly globalNavGroups: InputMaybe<CfGlobalNavNestedFilterType>;
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly title_exists: InputMaybe<Scalars['Boolean']>;
  readonly title: InputMaybe<Scalars['String']>;
  readonly title_not: InputMaybe<Scalars['String']>;
  readonly title_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_contains: InputMaybe<Scalars['String']>;
  readonly title_not_contains: InputMaybe<Scalars['String']>;
  readonly globalNavGroupsCollection_exists: InputMaybe<Scalars['Boolean']>;
  readonly globalNavLabel_exists: InputMaybe<Scalars['Boolean']>;
  readonly globalNavLabel: InputMaybe<Scalars['String']>;
  readonly globalNavLabel_not: InputMaybe<Scalars['String']>;
  readonly globalNavLabel_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly globalNavLabel_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly globalNavLabel_contains: InputMaybe<Scalars['String']>;
  readonly globalNavLabel_not_contains: InputMaybe<Scalars['String']>;
  readonly globalNavButtonAriaLabel_exists: InputMaybe<Scalars['Boolean']>;
  readonly globalNavButtonAriaLabel: InputMaybe<Scalars['String']>;
  readonly globalNavButtonAriaLabel_not: InputMaybe<Scalars['String']>;
  readonly globalNavButtonAriaLabel_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly globalNavButtonAriaLabel_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly globalNavButtonAriaLabel_contains: InputMaybe<Scalars['String']>;
  readonly globalNavButtonAriaLabel_not_contains: InputMaybe<Scalars['String']>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<GlobalNavConfigFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<GlobalNavConfigFilterType>>>;
};

export type CfGlobalNavNestedFilterType = {
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly title_exists: InputMaybe<Scalars['Boolean']>;
  readonly title: InputMaybe<Scalars['String']>;
  readonly title_not: InputMaybe<Scalars['String']>;
  readonly title_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_contains: InputMaybe<Scalars['String']>;
  readonly title_not_contains: InputMaybe<Scalars['String']>;
  readonly groupKey_exists: InputMaybe<Scalars['Boolean']>;
  readonly groupKey: InputMaybe<Scalars['String']>;
  readonly groupKey_not: InputMaybe<Scalars['String']>;
  readonly groupKey_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly groupKey_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly groupKey_contains: InputMaybe<Scalars['String']>;
  readonly groupKey_not_contains: InputMaybe<Scalars['String']>;
  readonly highlight_exists: InputMaybe<Scalars['Boolean']>;
  readonly itemsCollection_exists: InputMaybe<Scalars['Boolean']>;
  readonly primaryHostnameRegex_exists: InputMaybe<Scalars['Boolean']>;
  readonly primaryHostnameRegex: InputMaybe<Scalars['String']>;
  readonly primaryHostnameRegex_not: InputMaybe<Scalars['String']>;
  readonly primaryHostnameRegex_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly primaryHostnameRegex_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly primaryHostnameRegex_contains: InputMaybe<Scalars['String']>;
  readonly primaryHostnameRegex_not_contains: InputMaybe<Scalars['String']>;
  readonly hideHostnameRegex_exists: InputMaybe<Scalars['Boolean']>;
  readonly hideHostnameRegex: InputMaybe<Scalars['String']>;
  readonly hideHostnameRegex_not: InputMaybe<Scalars['String']>;
  readonly hideHostnameRegex_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly hideHostnameRegex_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly hideHostnameRegex_contains: InputMaybe<Scalars['String']>;
  readonly hideHostnameRegex_not_contains: InputMaybe<Scalars['String']>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<CfGlobalNavNestedFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<CfGlobalNavNestedFilterType>>>;
};

export enum GlobalNavConfigOrderType {
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  GlobalNavLabelAscType = 'globalNavLabel_ASC',
  GlobalNavLabelDescType = 'globalNavLabel_DESC',
  GlobalNavButtonAriaLabelAscType = 'globalNavButtonAriaLabel_ASC',
  GlobalNavButtonAriaLabelDescType = 'globalNavButtonAriaLabel_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieModal) */
export type CookieModalType = EntryType & _NodeType & {
  readonly __typename?: 'CookieModal';
  readonly sys: SysType;
  readonly contentfulMetadata: ContentfulMetadataType;
  readonly linkedFrom: Maybe<CookieModalLinkingCollectionsType>;
  readonly _id: Scalars['ID'];
  readonly contentfulDescription: Maybe<Scalars['String']>;
  readonly landingScreenTitle: Maybe<Scalars['String']>;
  readonly content: Maybe<CookieModalContentType>;
  readonly acceptAllButtonText: Maybe<Scalars['String']>;
  readonly essentialOnlyButtonText: Maybe<Scalars['String']>;
  readonly settingsButtonText: Maybe<Scalars['String']>;
  readonly settingsScreenTitle: Maybe<Scalars['String']>;
  readonly acceptSelectedButtonText: Maybe<Scalars['String']>;
  readonly saveChangesText: Maybe<Scalars['String']>;
  readonly changesSavedText: Maybe<Scalars['String']>;
  readonly toggleEnabledText: Maybe<Scalars['String']>;
  readonly toggleDisabledText: Maybe<Scalars['String']>;
  readonly cookieCategoriesCollection: Maybe<CookieModalCookieCategoriesCollectionType>;
  readonly gpcLocations: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly enableCookieDeletion: Maybe<Scalars['Boolean']>;
  readonly logCookieDeletion: Maybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieModal) */
export type CookieModalLinkedFromArgsType = {
  allowedLocales: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieModal) */
export type CookieModalContentfulDescriptionArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieModal) */
export type CookieModalLandingScreenTitleArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieModal) */
export type CookieModalContentArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieModal) */
export type CookieModalAcceptAllButtonTextArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieModal) */
export type CookieModalEssentialOnlyButtonTextArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieModal) */
export type CookieModalSettingsButtonTextArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieModal) */
export type CookieModalSettingsScreenTitleArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieModal) */
export type CookieModalAcceptSelectedButtonTextArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieModal) */
export type CookieModalSaveChangesTextArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieModal) */
export type CookieModalChangesSavedTextArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieModal) */
export type CookieModalToggleEnabledTextArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieModal) */
export type CookieModalToggleDisabledTextArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieModal) */
export type CookieModalCookieCategoriesCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<CookieCategoryFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<CookieModalCookieCategoriesCollectionOrderType>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieModal) */
export type CookieModalGpcLocationsArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieModal) */
export type CookieModalEnableCookieDeletionArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieModal) */
export type CookieModalLogCookieDeletionArgsType = {
  locale: InputMaybe<Scalars['String']>;
};

export type CookieModalLinkingCollectionsType = {
  readonly __typename?: 'CookieModalLinkingCollections';
  readonly entryCollection: Maybe<EntryCollectionType>;
};


export type CookieModalLinkingCollectionsEntryCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};

export type CookieModalContentType = {
  readonly __typename?: 'CookieModalContent';
  readonly json: Scalars['JSON'];
  readonly links: CookieModalContentLinksType;
};

export type CookieModalContentLinksType = {
  readonly __typename?: 'CookieModalContentLinks';
  readonly entries: CookieModalContentEntriesType;
  readonly assets: CookieModalContentAssetsType;
  readonly resources: CookieModalContentResourcesType;
};

export type CookieModalContentEntriesType = {
  readonly __typename?: 'CookieModalContentEntries';
  readonly inline: ReadonlyArray<Maybe<EntryType>>;
  readonly hyperlink: ReadonlyArray<Maybe<EntryType>>;
  readonly block: ReadonlyArray<Maybe<EntryType>>;
};

export type CookieModalContentAssetsType = {
  readonly __typename?: 'CookieModalContentAssets';
  readonly hyperlink: ReadonlyArray<Maybe<AssetType>>;
  readonly block: ReadonlyArray<Maybe<AssetType>>;
};

export type CookieModalContentResourcesType = {
  readonly __typename?: 'CookieModalContentResources';
  readonly block: ReadonlyArray<CookieModalContentResourcesBlockType>;
  readonly inline: ReadonlyArray<CookieModalContentResourcesInlineType>;
  readonly hyperlink: ReadonlyArray<CookieModalContentResourcesHyperlinkType>;
};

export type CookieModalContentResourcesBlockType = ResourceLinkType & {
  readonly __typename?: 'CookieModalContentResourcesBlock';
  readonly sys: ResourceSysType;
};

export type CookieModalContentResourcesInlineType = ResourceLinkType & {
  readonly __typename?: 'CookieModalContentResourcesInline';
  readonly sys: ResourceSysType;
};

export type CookieModalContentResourcesHyperlinkType = ResourceLinkType & {
  readonly __typename?: 'CookieModalContentResourcesHyperlink';
  readonly sys: ResourceSysType;
};

export type CookieModalCookieCategoriesCollectionType = {
  readonly __typename?: 'CookieModalCookieCategoriesCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<CookieCategoryType>>;
};

/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieCategory) */
export type CookieCategoryType = EntryType & _NodeType & {
  readonly __typename?: 'CookieCategory';
  readonly sys: SysType;
  readonly contentfulMetadata: ContentfulMetadataType;
  readonly linkedFrom: Maybe<CookieCategoryLinkingCollectionsType>;
  readonly _id: Scalars['ID'];
  readonly title: Maybe<Scalars['String']>;
  readonly description: Maybe<CookieCategoryDescriptionType>;
  readonly categoryCookieName: Maybe<Scalars['String']>;
  readonly displayMode: Maybe<Scalars['String']>;
  readonly isEssential: Maybe<Scalars['Boolean']>;
  readonly enableToggle: Maybe<Scalars['Boolean']>;
  readonly cookiesCollection: Maybe<CookieCategoryCookiesCollectionType>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieCategory) */
export type CookieCategoryLinkedFromArgsType = {
  allowedLocales: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieCategory) */
export type CookieCategoryTitleArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieCategory) */
export type CookieCategoryDescriptionArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieCategory) */
export type CookieCategoryCategoryCookieNameArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieCategory) */
export type CookieCategoryDisplayModeArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieCategory) */
export type CookieCategoryIsEssentialArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieCategory) */
export type CookieCategoryEnableToggleArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/cookieCategory) */
export type CookieCategoryCookiesCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  where: InputMaybe<TrackingCookieFilterType>;
  order: InputMaybe<ReadonlyArray<InputMaybe<CookieCategoryCookiesCollectionOrderType>>>;
};

export type CookieCategoryLinkingCollectionsType = {
  readonly __typename?: 'CookieCategoryLinkingCollections';
  readonly entryCollection: Maybe<EntryCollectionType>;
  readonly cookieModalCollection: Maybe<CookieModalCollectionType>;
};


export type CookieCategoryLinkingCollectionsEntryCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type CookieCategoryLinkingCollectionsCookieModalCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<ReadonlyArray<InputMaybe<CookieCategoryLinkingCollectionsCookieModalCollectionOrderType>>>;
};

export type CookieModalCollectionType = {
  readonly __typename?: 'CookieModalCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<CookieModalType>>;
};

export enum CookieCategoryLinkingCollectionsCookieModalCollectionOrderType {
  ContentfulDescriptionAscType = 'contentfulDescription_ASC',
  ContentfulDescriptionDescType = 'contentfulDescription_DESC',
  LandingScreenTitleAscType = 'landingScreenTitle_ASC',
  LandingScreenTitleDescType = 'landingScreenTitle_DESC',
  AcceptAllButtonTextAscType = 'acceptAllButtonText_ASC',
  AcceptAllButtonTextDescType = 'acceptAllButtonText_DESC',
  EssentialOnlyButtonTextAscType = 'essentialOnlyButtonText_ASC',
  EssentialOnlyButtonTextDescType = 'essentialOnlyButtonText_DESC',
  SettingsButtonTextAscType = 'settingsButtonText_ASC',
  SettingsButtonTextDescType = 'settingsButtonText_DESC',
  SettingsScreenTitleAscType = 'settingsScreenTitle_ASC',
  SettingsScreenTitleDescType = 'settingsScreenTitle_DESC',
  AcceptSelectedButtonTextAscType = 'acceptSelectedButtonText_ASC',
  AcceptSelectedButtonTextDescType = 'acceptSelectedButtonText_DESC',
  SaveChangesTextAscType = 'saveChangesText_ASC',
  SaveChangesTextDescType = 'saveChangesText_DESC',
  ChangesSavedTextAscType = 'changesSavedText_ASC',
  ChangesSavedTextDescType = 'changesSavedText_DESC',
  ToggleEnabledTextAscType = 'toggleEnabledText_ASC',
  ToggleEnabledTextDescType = 'toggleEnabledText_DESC',
  ToggleDisabledTextAscType = 'toggleDisabledText_ASC',
  ToggleDisabledTextDescType = 'toggleDisabledText_DESC',
  EnableCookieDeletionAscType = 'enableCookieDeletion_ASC',
  EnableCookieDeletionDescType = 'enableCookieDeletion_DESC',
  LogCookieDeletionAscType = 'logCookieDeletion_ASC',
  LogCookieDeletionDescType = 'logCookieDeletion_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export type CookieCategoryDescriptionType = {
  readonly __typename?: 'CookieCategoryDescription';
  readonly json: Scalars['JSON'];
  readonly links: CookieCategoryDescriptionLinksType;
};

export type CookieCategoryDescriptionLinksType = {
  readonly __typename?: 'CookieCategoryDescriptionLinks';
  readonly entries: CookieCategoryDescriptionEntriesType;
  readonly assets: CookieCategoryDescriptionAssetsType;
  readonly resources: CookieCategoryDescriptionResourcesType;
};

export type CookieCategoryDescriptionEntriesType = {
  readonly __typename?: 'CookieCategoryDescriptionEntries';
  readonly inline: ReadonlyArray<Maybe<EntryType>>;
  readonly hyperlink: ReadonlyArray<Maybe<EntryType>>;
  readonly block: ReadonlyArray<Maybe<EntryType>>;
};

export type CookieCategoryDescriptionAssetsType = {
  readonly __typename?: 'CookieCategoryDescriptionAssets';
  readonly hyperlink: ReadonlyArray<Maybe<AssetType>>;
  readonly block: ReadonlyArray<Maybe<AssetType>>;
};

export type CookieCategoryDescriptionResourcesType = {
  readonly __typename?: 'CookieCategoryDescriptionResources';
  readonly block: ReadonlyArray<CookieCategoryDescriptionResourcesBlockType>;
  readonly inline: ReadonlyArray<CookieCategoryDescriptionResourcesInlineType>;
  readonly hyperlink: ReadonlyArray<CookieCategoryDescriptionResourcesHyperlinkType>;
};

export type CookieCategoryDescriptionResourcesBlockType = ResourceLinkType & {
  readonly __typename?: 'CookieCategoryDescriptionResourcesBlock';
  readonly sys: ResourceSysType;
};

export type CookieCategoryDescriptionResourcesInlineType = ResourceLinkType & {
  readonly __typename?: 'CookieCategoryDescriptionResourcesInline';
  readonly sys: ResourceSysType;
};

export type CookieCategoryDescriptionResourcesHyperlinkType = ResourceLinkType & {
  readonly __typename?: 'CookieCategoryDescriptionResourcesHyperlink';
  readonly sys: ResourceSysType;
};

export type CookieCategoryCookiesCollectionType = {
  readonly __typename?: 'CookieCategoryCookiesCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<TrackingCookieType>>;
};

/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/trackingCookie) */
export type TrackingCookieType = EntryType & _NodeType & {
  readonly __typename?: 'TrackingCookie';
  readonly sys: SysType;
  readonly contentfulMetadata: ContentfulMetadataType;
  readonly linkedFrom: Maybe<TrackingCookieLinkingCollectionsType>;
  readonly _id: Scalars['ID'];
  readonly name: Maybe<Scalars['String']>;
  readonly provider: Maybe<TrackingCookieProviderType>;
  readonly domains: Maybe<TrackingCookieDomainsType>;
  readonly purpose: Maybe<TrackingCookiePurposeType>;
  readonly expiration: Maybe<TrackingCookieExpirationType>;
  readonly pattern: Maybe<Scalars['String']>;
  readonly subDomains: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly path: Maybe<Scalars['String']>;
  readonly secure: Maybe<Scalars['Boolean']>;
  readonly sameSite: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/trackingCookie) */
export type TrackingCookieLinkedFromArgsType = {
  allowedLocales: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/trackingCookie) */
export type TrackingCookieNameArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/trackingCookie) */
export type TrackingCookieProviderArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/trackingCookie) */
export type TrackingCookieDomainsArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/trackingCookie) */
export type TrackingCookiePurposeArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/trackingCookie) */
export type TrackingCookieExpirationArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/trackingCookie) */
export type TrackingCookiePatternArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/trackingCookie) */
export type TrackingCookieSubDomainsArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/trackingCookie) */
export type TrackingCookiePathArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/trackingCookie) */
export type TrackingCookieSecureArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/trackingCookie) */
export type TrackingCookieSameSiteArgsType = {
  locale: InputMaybe<Scalars['String']>;
};

export type TrackingCookieLinkingCollectionsType = {
  readonly __typename?: 'TrackingCookieLinkingCollections';
  readonly entryCollection: Maybe<EntryCollectionType>;
  readonly cookieCategoryCollection: Maybe<CookieCategoryCollectionType>;
};


export type TrackingCookieLinkingCollectionsEntryCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};


export type TrackingCookieLinkingCollectionsCookieCategoryCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<ReadonlyArray<InputMaybe<TrackingCookieLinkingCollectionsCookieCategoryCollectionOrderType>>>;
};

export type CookieCategoryCollectionType = {
  readonly __typename?: 'CookieCategoryCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<CookieCategoryType>>;
};

export enum TrackingCookieLinkingCollectionsCookieCategoryCollectionOrderType {
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  CategoryCookieNameAscType = 'categoryCookieName_ASC',
  CategoryCookieNameDescType = 'categoryCookieName_DESC',
  DisplayModeAscType = 'displayMode_ASC',
  DisplayModeDescType = 'displayMode_DESC',
  IsEssentialAscType = 'isEssential_ASC',
  IsEssentialDescType = 'isEssential_DESC',
  EnableToggleAscType = 'enableToggle_ASC',
  EnableToggleDescType = 'enableToggle_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export type TrackingCookieProviderType = {
  readonly __typename?: 'TrackingCookieProvider';
  readonly json: Scalars['JSON'];
  readonly links: TrackingCookieProviderLinksType;
};

export type TrackingCookieProviderLinksType = {
  readonly __typename?: 'TrackingCookieProviderLinks';
  readonly entries: TrackingCookieProviderEntriesType;
  readonly assets: TrackingCookieProviderAssetsType;
  readonly resources: TrackingCookieProviderResourcesType;
};

export type TrackingCookieProviderEntriesType = {
  readonly __typename?: 'TrackingCookieProviderEntries';
  readonly inline: ReadonlyArray<Maybe<EntryType>>;
  readonly hyperlink: ReadonlyArray<Maybe<EntryType>>;
  readonly block: ReadonlyArray<Maybe<EntryType>>;
};

export type TrackingCookieProviderAssetsType = {
  readonly __typename?: 'TrackingCookieProviderAssets';
  readonly hyperlink: ReadonlyArray<Maybe<AssetType>>;
  readonly block: ReadonlyArray<Maybe<AssetType>>;
};

export type TrackingCookieProviderResourcesType = {
  readonly __typename?: 'TrackingCookieProviderResources';
  readonly block: ReadonlyArray<TrackingCookieProviderResourcesBlockType>;
  readonly inline: ReadonlyArray<TrackingCookieProviderResourcesInlineType>;
  readonly hyperlink: ReadonlyArray<TrackingCookieProviderResourcesHyperlinkType>;
};

export type TrackingCookieProviderResourcesBlockType = ResourceLinkType & {
  readonly __typename?: 'TrackingCookieProviderResourcesBlock';
  readonly sys: ResourceSysType;
};

export type TrackingCookieProviderResourcesInlineType = ResourceLinkType & {
  readonly __typename?: 'TrackingCookieProviderResourcesInline';
  readonly sys: ResourceSysType;
};

export type TrackingCookieProviderResourcesHyperlinkType = ResourceLinkType & {
  readonly __typename?: 'TrackingCookieProviderResourcesHyperlink';
  readonly sys: ResourceSysType;
};

export type TrackingCookieDomainsType = {
  readonly __typename?: 'TrackingCookieDomains';
  readonly json: Scalars['JSON'];
  readonly links: TrackingCookieDomainsLinksType;
};

export type TrackingCookieDomainsLinksType = {
  readonly __typename?: 'TrackingCookieDomainsLinks';
  readonly entries: TrackingCookieDomainsEntriesType;
  readonly assets: TrackingCookieDomainsAssetsType;
  readonly resources: TrackingCookieDomainsResourcesType;
};

export type TrackingCookieDomainsEntriesType = {
  readonly __typename?: 'TrackingCookieDomainsEntries';
  readonly inline: ReadonlyArray<Maybe<EntryType>>;
  readonly hyperlink: ReadonlyArray<Maybe<EntryType>>;
  readonly block: ReadonlyArray<Maybe<EntryType>>;
};

export type TrackingCookieDomainsAssetsType = {
  readonly __typename?: 'TrackingCookieDomainsAssets';
  readonly hyperlink: ReadonlyArray<Maybe<AssetType>>;
  readonly block: ReadonlyArray<Maybe<AssetType>>;
};

export type TrackingCookieDomainsResourcesType = {
  readonly __typename?: 'TrackingCookieDomainsResources';
  readonly block: ReadonlyArray<TrackingCookieDomainsResourcesBlockType>;
  readonly inline: ReadonlyArray<TrackingCookieDomainsResourcesInlineType>;
  readonly hyperlink: ReadonlyArray<TrackingCookieDomainsResourcesHyperlinkType>;
};

export type TrackingCookieDomainsResourcesBlockType = ResourceLinkType & {
  readonly __typename?: 'TrackingCookieDomainsResourcesBlock';
  readonly sys: ResourceSysType;
};

export type TrackingCookieDomainsResourcesInlineType = ResourceLinkType & {
  readonly __typename?: 'TrackingCookieDomainsResourcesInline';
  readonly sys: ResourceSysType;
};

export type TrackingCookieDomainsResourcesHyperlinkType = ResourceLinkType & {
  readonly __typename?: 'TrackingCookieDomainsResourcesHyperlink';
  readonly sys: ResourceSysType;
};

export type TrackingCookiePurposeType = {
  readonly __typename?: 'TrackingCookiePurpose';
  readonly json: Scalars['JSON'];
  readonly links: TrackingCookiePurposeLinksType;
};

export type TrackingCookiePurposeLinksType = {
  readonly __typename?: 'TrackingCookiePurposeLinks';
  readonly entries: TrackingCookiePurposeEntriesType;
  readonly assets: TrackingCookiePurposeAssetsType;
  readonly resources: TrackingCookiePurposeResourcesType;
};

export type TrackingCookiePurposeEntriesType = {
  readonly __typename?: 'TrackingCookiePurposeEntries';
  readonly inline: ReadonlyArray<Maybe<EntryType>>;
  readonly hyperlink: ReadonlyArray<Maybe<EntryType>>;
  readonly block: ReadonlyArray<Maybe<EntryType>>;
};

export type TrackingCookiePurposeAssetsType = {
  readonly __typename?: 'TrackingCookiePurposeAssets';
  readonly hyperlink: ReadonlyArray<Maybe<AssetType>>;
  readonly block: ReadonlyArray<Maybe<AssetType>>;
};

export type TrackingCookiePurposeResourcesType = {
  readonly __typename?: 'TrackingCookiePurposeResources';
  readonly block: ReadonlyArray<TrackingCookiePurposeResourcesBlockType>;
  readonly inline: ReadonlyArray<TrackingCookiePurposeResourcesInlineType>;
  readonly hyperlink: ReadonlyArray<TrackingCookiePurposeResourcesHyperlinkType>;
};

export type TrackingCookiePurposeResourcesBlockType = ResourceLinkType & {
  readonly __typename?: 'TrackingCookiePurposeResourcesBlock';
  readonly sys: ResourceSysType;
};

export type TrackingCookiePurposeResourcesInlineType = ResourceLinkType & {
  readonly __typename?: 'TrackingCookiePurposeResourcesInline';
  readonly sys: ResourceSysType;
};

export type TrackingCookiePurposeResourcesHyperlinkType = ResourceLinkType & {
  readonly __typename?: 'TrackingCookiePurposeResourcesHyperlink';
  readonly sys: ResourceSysType;
};

export type TrackingCookieExpirationType = {
  readonly __typename?: 'TrackingCookieExpiration';
  readonly json: Scalars['JSON'];
  readonly links: TrackingCookieExpirationLinksType;
};

export type TrackingCookieExpirationLinksType = {
  readonly __typename?: 'TrackingCookieExpirationLinks';
  readonly entries: TrackingCookieExpirationEntriesType;
  readonly assets: TrackingCookieExpirationAssetsType;
  readonly resources: TrackingCookieExpirationResourcesType;
};

export type TrackingCookieExpirationEntriesType = {
  readonly __typename?: 'TrackingCookieExpirationEntries';
  readonly inline: ReadonlyArray<Maybe<EntryType>>;
  readonly hyperlink: ReadonlyArray<Maybe<EntryType>>;
  readonly block: ReadonlyArray<Maybe<EntryType>>;
};

export type TrackingCookieExpirationAssetsType = {
  readonly __typename?: 'TrackingCookieExpirationAssets';
  readonly hyperlink: ReadonlyArray<Maybe<AssetType>>;
  readonly block: ReadonlyArray<Maybe<AssetType>>;
};

export type TrackingCookieExpirationResourcesType = {
  readonly __typename?: 'TrackingCookieExpirationResources';
  readonly block: ReadonlyArray<TrackingCookieExpirationResourcesBlockType>;
  readonly inline: ReadonlyArray<TrackingCookieExpirationResourcesInlineType>;
  readonly hyperlink: ReadonlyArray<TrackingCookieExpirationResourcesHyperlinkType>;
};

export type TrackingCookieExpirationResourcesBlockType = ResourceLinkType & {
  readonly __typename?: 'TrackingCookieExpirationResourcesBlock';
  readonly sys: ResourceSysType;
};

export type TrackingCookieExpirationResourcesInlineType = ResourceLinkType & {
  readonly __typename?: 'TrackingCookieExpirationResourcesInline';
  readonly sys: ResourceSysType;
};

export type TrackingCookieExpirationResourcesHyperlinkType = ResourceLinkType & {
  readonly __typename?: 'TrackingCookieExpirationResourcesHyperlink';
  readonly sys: ResourceSysType;
};

export type TrackingCookieFilterType = {
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly name_exists: InputMaybe<Scalars['Boolean']>;
  readonly name: InputMaybe<Scalars['String']>;
  readonly name_not: InputMaybe<Scalars['String']>;
  readonly name_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly name_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly name_contains: InputMaybe<Scalars['String']>;
  readonly name_not_contains: InputMaybe<Scalars['String']>;
  readonly provider_exists: InputMaybe<Scalars['Boolean']>;
  readonly provider_contains: InputMaybe<Scalars['String']>;
  readonly provider_not_contains: InputMaybe<Scalars['String']>;
  readonly domains_exists: InputMaybe<Scalars['Boolean']>;
  readonly domains_contains: InputMaybe<Scalars['String']>;
  readonly domains_not_contains: InputMaybe<Scalars['String']>;
  readonly purpose_exists: InputMaybe<Scalars['Boolean']>;
  readonly purpose_contains: InputMaybe<Scalars['String']>;
  readonly purpose_not_contains: InputMaybe<Scalars['String']>;
  readonly expiration_exists: InputMaybe<Scalars['Boolean']>;
  readonly expiration_contains: InputMaybe<Scalars['String']>;
  readonly expiration_not_contains: InputMaybe<Scalars['String']>;
  readonly pattern_exists: InputMaybe<Scalars['Boolean']>;
  readonly pattern: InputMaybe<Scalars['String']>;
  readonly pattern_not: InputMaybe<Scalars['String']>;
  readonly pattern_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly pattern_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly pattern_contains: InputMaybe<Scalars['String']>;
  readonly pattern_not_contains: InputMaybe<Scalars['String']>;
  readonly subDomains_exists: InputMaybe<Scalars['Boolean']>;
  readonly subDomains_contains_all: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly subDomains_contains_some: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly subDomains_contains_none: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly path_exists: InputMaybe<Scalars['Boolean']>;
  readonly path: InputMaybe<Scalars['String']>;
  readonly path_not: InputMaybe<Scalars['String']>;
  readonly path_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly path_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly path_contains: InputMaybe<Scalars['String']>;
  readonly path_not_contains: InputMaybe<Scalars['String']>;
  readonly secure_exists: InputMaybe<Scalars['Boolean']>;
  readonly secure: InputMaybe<Scalars['Boolean']>;
  readonly secure_not: InputMaybe<Scalars['Boolean']>;
  readonly sameSite_exists: InputMaybe<Scalars['Boolean']>;
  readonly sameSite: InputMaybe<Scalars['String']>;
  readonly sameSite_not: InputMaybe<Scalars['String']>;
  readonly sameSite_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly sameSite_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly sameSite_contains: InputMaybe<Scalars['String']>;
  readonly sameSite_not_contains: InputMaybe<Scalars['String']>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<TrackingCookieFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<TrackingCookieFilterType>>>;
};

export enum CookieCategoryCookiesCollectionOrderType {
  NameAscType = 'name_ASC',
  NameDescType = 'name_DESC',
  PatternAscType = 'pattern_ASC',
  PatternDescType = 'pattern_DESC',
  PathAscType = 'path_ASC',
  PathDescType = 'path_DESC',
  SecureAscType = 'secure_ASC',
  SecureDescType = 'secure_DESC',
  SameSiteAscType = 'sameSite_ASC',
  SameSiteDescType = 'sameSite_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export type CookieCategoryFilterType = {
  readonly cookies: InputMaybe<CfTrackingCookieNestedFilterType>;
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly title_exists: InputMaybe<Scalars['Boolean']>;
  readonly title: InputMaybe<Scalars['String']>;
  readonly title_not: InputMaybe<Scalars['String']>;
  readonly title_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_contains: InputMaybe<Scalars['String']>;
  readonly title_not_contains: InputMaybe<Scalars['String']>;
  readonly description_exists: InputMaybe<Scalars['Boolean']>;
  readonly description_contains: InputMaybe<Scalars['String']>;
  readonly description_not_contains: InputMaybe<Scalars['String']>;
  readonly categoryCookieName_exists: InputMaybe<Scalars['Boolean']>;
  readonly categoryCookieName: InputMaybe<Scalars['String']>;
  readonly categoryCookieName_not: InputMaybe<Scalars['String']>;
  readonly categoryCookieName_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly categoryCookieName_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly categoryCookieName_contains: InputMaybe<Scalars['String']>;
  readonly categoryCookieName_not_contains: InputMaybe<Scalars['String']>;
  readonly displayMode_exists: InputMaybe<Scalars['Boolean']>;
  readonly displayMode: InputMaybe<Scalars['String']>;
  readonly displayMode_not: InputMaybe<Scalars['String']>;
  readonly displayMode_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly displayMode_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly displayMode_contains: InputMaybe<Scalars['String']>;
  readonly displayMode_not_contains: InputMaybe<Scalars['String']>;
  readonly isEssential_exists: InputMaybe<Scalars['Boolean']>;
  readonly isEssential: InputMaybe<Scalars['Boolean']>;
  readonly isEssential_not: InputMaybe<Scalars['Boolean']>;
  readonly enableToggle_exists: InputMaybe<Scalars['Boolean']>;
  readonly enableToggle: InputMaybe<Scalars['Boolean']>;
  readonly enableToggle_not: InputMaybe<Scalars['Boolean']>;
  readonly cookiesCollection_exists: InputMaybe<Scalars['Boolean']>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<CookieCategoryFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<CookieCategoryFilterType>>>;
};

export type CfTrackingCookieNestedFilterType = {
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly name_exists: InputMaybe<Scalars['Boolean']>;
  readonly name: InputMaybe<Scalars['String']>;
  readonly name_not: InputMaybe<Scalars['String']>;
  readonly name_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly name_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly name_contains: InputMaybe<Scalars['String']>;
  readonly name_not_contains: InputMaybe<Scalars['String']>;
  readonly provider_exists: InputMaybe<Scalars['Boolean']>;
  readonly provider_contains: InputMaybe<Scalars['String']>;
  readonly provider_not_contains: InputMaybe<Scalars['String']>;
  readonly domains_exists: InputMaybe<Scalars['Boolean']>;
  readonly domains_contains: InputMaybe<Scalars['String']>;
  readonly domains_not_contains: InputMaybe<Scalars['String']>;
  readonly purpose_exists: InputMaybe<Scalars['Boolean']>;
  readonly purpose_contains: InputMaybe<Scalars['String']>;
  readonly purpose_not_contains: InputMaybe<Scalars['String']>;
  readonly expiration_exists: InputMaybe<Scalars['Boolean']>;
  readonly expiration_contains: InputMaybe<Scalars['String']>;
  readonly expiration_not_contains: InputMaybe<Scalars['String']>;
  readonly pattern_exists: InputMaybe<Scalars['Boolean']>;
  readonly pattern: InputMaybe<Scalars['String']>;
  readonly pattern_not: InputMaybe<Scalars['String']>;
  readonly pattern_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly pattern_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly pattern_contains: InputMaybe<Scalars['String']>;
  readonly pattern_not_contains: InputMaybe<Scalars['String']>;
  readonly subDomains_exists: InputMaybe<Scalars['Boolean']>;
  readonly subDomains_contains_all: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly subDomains_contains_some: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly subDomains_contains_none: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly path_exists: InputMaybe<Scalars['Boolean']>;
  readonly path: InputMaybe<Scalars['String']>;
  readonly path_not: InputMaybe<Scalars['String']>;
  readonly path_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly path_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly path_contains: InputMaybe<Scalars['String']>;
  readonly path_not_contains: InputMaybe<Scalars['String']>;
  readonly secure_exists: InputMaybe<Scalars['Boolean']>;
  readonly secure: InputMaybe<Scalars['Boolean']>;
  readonly secure_not: InputMaybe<Scalars['Boolean']>;
  readonly sameSite_exists: InputMaybe<Scalars['Boolean']>;
  readonly sameSite: InputMaybe<Scalars['String']>;
  readonly sameSite_not: InputMaybe<Scalars['String']>;
  readonly sameSite_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly sameSite_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly sameSite_contains: InputMaybe<Scalars['String']>;
  readonly sameSite_not_contains: InputMaybe<Scalars['String']>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<CfTrackingCookieNestedFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<CfTrackingCookieNestedFilterType>>>;
};

export enum CookieModalCookieCategoriesCollectionOrderType {
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  CategoryCookieNameAscType = 'categoryCookieName_ASC',
  CategoryCookieNameDescType = 'categoryCookieName_DESC',
  DisplayModeAscType = 'displayMode_ASC',
  DisplayModeDescType = 'displayMode_DESC',
  IsEssentialAscType = 'isEssential_ASC',
  IsEssentialDescType = 'isEssential_DESC',
  EnableToggleAscType = 'enableToggle_ASC',
  EnableToggleDescType = 'enableToggle_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export type CookieModalFilterType = {
  readonly cookieCategories: InputMaybe<CfCookieCategoryNestedFilterType>;
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly contentfulDescription_exists: InputMaybe<Scalars['Boolean']>;
  readonly contentfulDescription: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_not: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentfulDescription_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentfulDescription_contains: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_not_contains: InputMaybe<Scalars['String']>;
  readonly landingScreenTitle_exists: InputMaybe<Scalars['Boolean']>;
  readonly landingScreenTitle: InputMaybe<Scalars['String']>;
  readonly landingScreenTitle_not: InputMaybe<Scalars['String']>;
  readonly landingScreenTitle_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly landingScreenTitle_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly landingScreenTitle_contains: InputMaybe<Scalars['String']>;
  readonly landingScreenTitle_not_contains: InputMaybe<Scalars['String']>;
  readonly content_exists: InputMaybe<Scalars['Boolean']>;
  readonly content_contains: InputMaybe<Scalars['String']>;
  readonly content_not_contains: InputMaybe<Scalars['String']>;
  readonly acceptAllButtonText_exists: InputMaybe<Scalars['Boolean']>;
  readonly acceptAllButtonText: InputMaybe<Scalars['String']>;
  readonly acceptAllButtonText_not: InputMaybe<Scalars['String']>;
  readonly acceptAllButtonText_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly acceptAllButtonText_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly acceptAllButtonText_contains: InputMaybe<Scalars['String']>;
  readonly acceptAllButtonText_not_contains: InputMaybe<Scalars['String']>;
  readonly essentialOnlyButtonText_exists: InputMaybe<Scalars['Boolean']>;
  readonly essentialOnlyButtonText: InputMaybe<Scalars['String']>;
  readonly essentialOnlyButtonText_not: InputMaybe<Scalars['String']>;
  readonly essentialOnlyButtonText_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly essentialOnlyButtonText_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly essentialOnlyButtonText_contains: InputMaybe<Scalars['String']>;
  readonly essentialOnlyButtonText_not_contains: InputMaybe<Scalars['String']>;
  readonly settingsButtonText_exists: InputMaybe<Scalars['Boolean']>;
  readonly settingsButtonText: InputMaybe<Scalars['String']>;
  readonly settingsButtonText_not: InputMaybe<Scalars['String']>;
  readonly settingsButtonText_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly settingsButtonText_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly settingsButtonText_contains: InputMaybe<Scalars['String']>;
  readonly settingsButtonText_not_contains: InputMaybe<Scalars['String']>;
  readonly settingsScreenTitle_exists: InputMaybe<Scalars['Boolean']>;
  readonly settingsScreenTitle: InputMaybe<Scalars['String']>;
  readonly settingsScreenTitle_not: InputMaybe<Scalars['String']>;
  readonly settingsScreenTitle_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly settingsScreenTitle_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly settingsScreenTitle_contains: InputMaybe<Scalars['String']>;
  readonly settingsScreenTitle_not_contains: InputMaybe<Scalars['String']>;
  readonly acceptSelectedButtonText_exists: InputMaybe<Scalars['Boolean']>;
  readonly acceptSelectedButtonText: InputMaybe<Scalars['String']>;
  readonly acceptSelectedButtonText_not: InputMaybe<Scalars['String']>;
  readonly acceptSelectedButtonText_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly acceptSelectedButtonText_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly acceptSelectedButtonText_contains: InputMaybe<Scalars['String']>;
  readonly acceptSelectedButtonText_not_contains: InputMaybe<Scalars['String']>;
  readonly saveChangesText_exists: InputMaybe<Scalars['Boolean']>;
  readonly saveChangesText: InputMaybe<Scalars['String']>;
  readonly saveChangesText_not: InputMaybe<Scalars['String']>;
  readonly saveChangesText_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly saveChangesText_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly saveChangesText_contains: InputMaybe<Scalars['String']>;
  readonly saveChangesText_not_contains: InputMaybe<Scalars['String']>;
  readonly changesSavedText_exists: InputMaybe<Scalars['Boolean']>;
  readonly changesSavedText: InputMaybe<Scalars['String']>;
  readonly changesSavedText_not: InputMaybe<Scalars['String']>;
  readonly changesSavedText_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly changesSavedText_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly changesSavedText_contains: InputMaybe<Scalars['String']>;
  readonly changesSavedText_not_contains: InputMaybe<Scalars['String']>;
  readonly toggleEnabledText_exists: InputMaybe<Scalars['Boolean']>;
  readonly toggleEnabledText: InputMaybe<Scalars['String']>;
  readonly toggleEnabledText_not: InputMaybe<Scalars['String']>;
  readonly toggleEnabledText_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly toggleEnabledText_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly toggleEnabledText_contains: InputMaybe<Scalars['String']>;
  readonly toggleEnabledText_not_contains: InputMaybe<Scalars['String']>;
  readonly toggleDisabledText_exists: InputMaybe<Scalars['Boolean']>;
  readonly toggleDisabledText: InputMaybe<Scalars['String']>;
  readonly toggleDisabledText_not: InputMaybe<Scalars['String']>;
  readonly toggleDisabledText_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly toggleDisabledText_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly toggleDisabledText_contains: InputMaybe<Scalars['String']>;
  readonly toggleDisabledText_not_contains: InputMaybe<Scalars['String']>;
  readonly cookieCategoriesCollection_exists: InputMaybe<Scalars['Boolean']>;
  readonly gpcLocations_exists: InputMaybe<Scalars['Boolean']>;
  readonly gpcLocations_contains_all: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly gpcLocations_contains_some: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly gpcLocations_contains_none: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly enableCookieDeletion_exists: InputMaybe<Scalars['Boolean']>;
  readonly enableCookieDeletion: InputMaybe<Scalars['Boolean']>;
  readonly enableCookieDeletion_not: InputMaybe<Scalars['Boolean']>;
  readonly logCookieDeletion_exists: InputMaybe<Scalars['Boolean']>;
  readonly logCookieDeletion: InputMaybe<Scalars['Boolean']>;
  readonly logCookieDeletion_not: InputMaybe<Scalars['Boolean']>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<CookieModalFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<CookieModalFilterType>>>;
};

export type CfCookieCategoryNestedFilterType = {
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly title_exists: InputMaybe<Scalars['Boolean']>;
  readonly title: InputMaybe<Scalars['String']>;
  readonly title_not: InputMaybe<Scalars['String']>;
  readonly title_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_contains: InputMaybe<Scalars['String']>;
  readonly title_not_contains: InputMaybe<Scalars['String']>;
  readonly description_exists: InputMaybe<Scalars['Boolean']>;
  readonly description_contains: InputMaybe<Scalars['String']>;
  readonly description_not_contains: InputMaybe<Scalars['String']>;
  readonly categoryCookieName_exists: InputMaybe<Scalars['Boolean']>;
  readonly categoryCookieName: InputMaybe<Scalars['String']>;
  readonly categoryCookieName_not: InputMaybe<Scalars['String']>;
  readonly categoryCookieName_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly categoryCookieName_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly categoryCookieName_contains: InputMaybe<Scalars['String']>;
  readonly categoryCookieName_not_contains: InputMaybe<Scalars['String']>;
  readonly displayMode_exists: InputMaybe<Scalars['Boolean']>;
  readonly displayMode: InputMaybe<Scalars['String']>;
  readonly displayMode_not: InputMaybe<Scalars['String']>;
  readonly displayMode_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly displayMode_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly displayMode_contains: InputMaybe<Scalars['String']>;
  readonly displayMode_not_contains: InputMaybe<Scalars['String']>;
  readonly isEssential_exists: InputMaybe<Scalars['Boolean']>;
  readonly isEssential: InputMaybe<Scalars['Boolean']>;
  readonly isEssential_not: InputMaybe<Scalars['Boolean']>;
  readonly enableToggle_exists: InputMaybe<Scalars['Boolean']>;
  readonly enableToggle: InputMaybe<Scalars['Boolean']>;
  readonly enableToggle_not: InputMaybe<Scalars['Boolean']>;
  readonly cookiesCollection_exists: InputMaybe<Scalars['Boolean']>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<CfCookieCategoryNestedFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<CfCookieCategoryNestedFilterType>>>;
};

export enum CookieModalOrderType {
  ContentfulDescriptionAscType = 'contentfulDescription_ASC',
  ContentfulDescriptionDescType = 'contentfulDescription_DESC',
  LandingScreenTitleAscType = 'landingScreenTitle_ASC',
  LandingScreenTitleDescType = 'landingScreenTitle_DESC',
  AcceptAllButtonTextAscType = 'acceptAllButtonText_ASC',
  AcceptAllButtonTextDescType = 'acceptAllButtonText_DESC',
  EssentialOnlyButtonTextAscType = 'essentialOnlyButtonText_ASC',
  EssentialOnlyButtonTextDescType = 'essentialOnlyButtonText_DESC',
  SettingsButtonTextAscType = 'settingsButtonText_ASC',
  SettingsButtonTextDescType = 'settingsButtonText_DESC',
  SettingsScreenTitleAscType = 'settingsScreenTitle_ASC',
  SettingsScreenTitleDescType = 'settingsScreenTitle_DESC',
  AcceptSelectedButtonTextAscType = 'acceptSelectedButtonText_ASC',
  AcceptSelectedButtonTextDescType = 'acceptSelectedButtonText_DESC',
  SaveChangesTextAscType = 'saveChangesText_ASC',
  SaveChangesTextDescType = 'saveChangesText_DESC',
  ChangesSavedTextAscType = 'changesSavedText_ASC',
  ChangesSavedTextDescType = 'changesSavedText_DESC',
  ToggleEnabledTextAscType = 'toggleEnabledText_ASC',
  ToggleEnabledTextDescType = 'toggleEnabledText_DESC',
  ToggleDisabledTextAscType = 'toggleDisabledText_ASC',
  ToggleDisabledTextDescType = 'toggleDisabledText_DESC',
  EnableCookieDeletionAscType = 'enableCookieDeletion_ASC',
  EnableCookieDeletionDescType = 'enableCookieDeletion_DESC',
  LogCookieDeletionAscType = 'logCookieDeletion_ASC',
  LogCookieDeletionDescType = 'logCookieDeletion_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export type TrackingCookieCollectionType = {
  readonly __typename?: 'TrackingCookieCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<TrackingCookieType>>;
};

export enum TrackingCookieOrderType {
  NameAscType = 'name_ASC',
  NameDescType = 'name_DESC',
  PatternAscType = 'pattern_ASC',
  PatternDescType = 'pattern_DESC',
  PathAscType = 'path_ASC',
  PathDescType = 'path_DESC',
  SecureAscType = 'secure_ASC',
  SecureDescType = 'secure_DESC',
  SameSiteAscType = 'sameSite_ASC',
  SameSiteDescType = 'sameSite_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export enum ImageOrderType {
  ContentfulDescriptionAscType = 'contentfulDescription_ASC',
  ContentfulDescriptionDescType = 'contentfulDescription_DESC',
  WrapAscType = 'wrap_ASC',
  WrapDescType = 'wrap_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export enum GlobalNavHighlightOrderType {
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  CardTitleV2AscType = 'cardTitleV2_ASC',
  CardTitleV2DescType = 'cardTitleV2_DESC',
  CardBodyV2AscType = 'cardBodyV2_ASC',
  CardBodyV2DescType = 'cardBodyV2_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export enum GlobalNavOrderType {
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  GroupKeyAscType = 'groupKey_ASC',
  GroupKeyDescType = 'groupKey_DESC',
  PrimaryHostnameRegexAscType = 'primaryHostnameRegex_ASC',
  PrimaryHostnameRegexDescType = 'primaryHostnameRegex_DESC',
  HideHostnameRegexAscType = 'hideHostnameRegex_ASC',
  HideHostnameRegexDescType = 'hideHostnameRegex_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export enum CookieCategoryOrderType {
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  CategoryCookieNameAscType = 'categoryCookieName_ASC',
  CategoryCookieNameDescType = 'categoryCookieName_DESC',
  DisplayModeAscType = 'displayMode_ASC',
  DisplayModeDescType = 'displayMode_DESC',
  IsEssentialAscType = 'isEssential_ASC',
  IsEssentialDescType = 'isEssential_DESC',
  EnableToggleAscType = 'enableToggle_ASC',
  EnableToggleDescType = 'enableToggle_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export type FooterV3FilterType = {
  readonly columns: InputMaybe<CfFooterGroupNestedFilterType>;
  readonly bar: InputMaybe<CfFooterGroupNestedFilterType>;
  readonly logo: InputMaybe<CfImageNestedFilterType>;
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly contentfulDescription_exists: InputMaybe<Scalars['Boolean']>;
  readonly contentfulDescription: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_not: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentfulDescription_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentfulDescription_contains: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_not_contains: InputMaybe<Scalars['String']>;
  readonly columnsCollection_exists: InputMaybe<Scalars['Boolean']>;
  readonly barCollection_exists: InputMaybe<Scalars['Boolean']>;
  readonly logo_exists: InputMaybe<Scalars['Boolean']>;
  readonly url_exists: InputMaybe<Scalars['Boolean']>;
  readonly url: InputMaybe<Scalars['String']>;
  readonly url_not: InputMaybe<Scalars['String']>;
  readonly url_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly url_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly url_contains: InputMaybe<Scalars['String']>;
  readonly url_not_contains: InputMaybe<Scalars['String']>;
  readonly hideLogoOnDomains_exists: InputMaybe<Scalars['Boolean']>;
  readonly hideLogoOnDomains_contains_all: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly hideLogoOnDomains_contains_some: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly hideLogoOnDomains_contains_none: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<FooterV3FilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<FooterV3FilterType>>>;
};

export type CfFooterGroupNestedFilterType = {
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly contentfulDescription_exists: InputMaybe<Scalars['Boolean']>;
  readonly contentfulDescription: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_not: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentfulDescription_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentfulDescription_contains: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_not_contains: InputMaybe<Scalars['String']>;
  readonly title_exists: InputMaybe<Scalars['Boolean']>;
  readonly title: InputMaybe<Scalars['String']>;
  readonly title_not: InputMaybe<Scalars['String']>;
  readonly title_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_contains: InputMaybe<Scalars['String']>;
  readonly title_not_contains: InputMaybe<Scalars['String']>;
  readonly groupKey_exists: InputMaybe<Scalars['Boolean']>;
  readonly groupKey: InputMaybe<Scalars['String']>;
  readonly groupKey_not: InputMaybe<Scalars['String']>;
  readonly groupKey_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly groupKey_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly groupKey_contains: InputMaybe<Scalars['String']>;
  readonly groupKey_not_contains: InputMaybe<Scalars['String']>;
  readonly itemsCollection_exists: InputMaybe<Scalars['Boolean']>;
  readonly analytics_exists: InputMaybe<Scalars['Boolean']>;
  readonly hideOnDomains_exists: InputMaybe<Scalars['Boolean']>;
  readonly hideOnDomains_contains_all: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly hideOnDomains_contains_some: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly hideOnDomains_contains_none: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<CfFooterGroupNestedFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<CfFooterGroupNestedFilterType>>>;
};

export type CfImageNestedFilterType = {
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly contentfulDescription_exists: InputMaybe<Scalars['Boolean']>;
  readonly contentfulDescription: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_not: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentfulDescription_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentfulDescription_contains: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_not_contains: InputMaybe<Scalars['String']>;
  readonly media_exists: InputMaybe<Scalars['Boolean']>;
  readonly wrap_exists: InputMaybe<Scalars['Boolean']>;
  readonly wrap: InputMaybe<Scalars['String']>;
  readonly wrap_not: InputMaybe<Scalars['String']>;
  readonly wrap_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly wrap_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly wrap_contains: InputMaybe<Scalars['String']>;
  readonly wrap_not_contains: InputMaybe<Scalars['String']>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<CfImageNestedFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<CfImageNestedFilterType>>>;
};

export enum FooterV3OrderType {
  ContentfulDescriptionAscType = 'contentfulDescription_ASC',
  ContentfulDescriptionDescType = 'contentfulDescription_DESC',
  UrlAscType = 'url_ASC',
  UrlDescType = 'url_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export type FooterItemV3FilterType = {
  readonly analytics: InputMaybe<CfAnalyticsNestedFilterType>;
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly contentfulDescription_exists: InputMaybe<Scalars['Boolean']>;
  readonly contentfulDescription: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_not: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentfulDescription_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentfulDescription_contains: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_not_contains: InputMaybe<Scalars['String']>;
  readonly title_exists: InputMaybe<Scalars['Boolean']>;
  readonly title: InputMaybe<Scalars['String']>;
  readonly title_not: InputMaybe<Scalars['String']>;
  readonly title_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_contains: InputMaybe<Scalars['String']>;
  readonly title_not_contains: InputMaybe<Scalars['String']>;
  readonly url_exists: InputMaybe<Scalars['Boolean']>;
  readonly url: InputMaybe<Scalars['String']>;
  readonly url_not: InputMaybe<Scalars['String']>;
  readonly url_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly url_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly url_contains: InputMaybe<Scalars['String']>;
  readonly url_not_contains: InputMaybe<Scalars['String']>;
  readonly analytics_exists: InputMaybe<Scalars['Boolean']>;
  readonly hideOnDomains_exists: InputMaybe<Scalars['Boolean']>;
  readonly hideOnDomains_contains_all: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly hideOnDomains_contains_some: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly hideOnDomains_contains_none: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<FooterItemV3FilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<FooterItemV3FilterType>>>;
};

export enum FooterItemV3OrderType {
  ContentfulDescriptionAscType = 'contentfulDescription_ASC',
  ContentfulDescriptionDescType = 'contentfulDescription_DESC',
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  UrlAscType = 'url_ASC',
  UrlDescType = 'url_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export type FooterLocaleDropdownCollectionType = {
  readonly __typename?: 'FooterLocaleDropdownCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<FooterLocaleDropdownType>>;
};

export type FooterLocaleDropdownFilterType = {
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly contentfulDescription_exists: InputMaybe<Scalars['Boolean']>;
  readonly contentfulDescription: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_not: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentfulDescription_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentfulDescription_contains: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_not_contains: InputMaybe<Scalars['String']>;
  readonly title_exists: InputMaybe<Scalars['Boolean']>;
  readonly title: InputMaybe<Scalars['String']>;
  readonly title_not: InputMaybe<Scalars['String']>;
  readonly title_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_contains: InputMaybe<Scalars['String']>;
  readonly title_not_contains: InputMaybe<Scalars['String']>;
  readonly hideOnDomains_exists: InputMaybe<Scalars['Boolean']>;
  readonly hideOnDomains_contains_all: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly hideOnDomains_contains_some: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly hideOnDomains_contains_none: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<FooterLocaleDropdownFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<FooterLocaleDropdownFilterType>>>;
};

export enum FooterLocaleDropdownOrderType {
  ContentfulDescriptionAscType = 'contentfulDescription_ASC',
  ContentfulDescriptionDescType = 'contentfulDescription_DESC',
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export type FooterCookiesSettingsLinkFilterType = {
  readonly analytics: InputMaybe<CfAnalyticsNestedFilterType>;
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly contentfulDescription_exists: InputMaybe<Scalars['Boolean']>;
  readonly contentfulDescription: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_not: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentfulDescription_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentfulDescription_contains: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_not_contains: InputMaybe<Scalars['String']>;
  readonly title_exists: InputMaybe<Scalars['Boolean']>;
  readonly title: InputMaybe<Scalars['String']>;
  readonly title_not: InputMaybe<Scalars['String']>;
  readonly title_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_contains: InputMaybe<Scalars['String']>;
  readonly title_not_contains: InputMaybe<Scalars['String']>;
  readonly hideOnDomains_exists: InputMaybe<Scalars['Boolean']>;
  readonly hideOnDomains_contains_all: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly hideOnDomains_contains_some: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly hideOnDomains_contains_none: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly analytics_exists: InputMaybe<Scalars['Boolean']>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<FooterCookiesSettingsLinkFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<FooterCookiesSettingsLinkFilterType>>>;
};

export enum FooterCookiesSettingsLinkOrderType {
  ContentfulDescriptionAscType = 'contentfulDescription_ASC',
  ContentfulDescriptionDescType = 'contentfulDescription_DESC',
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export enum FooterGroupOrderType {
  ContentfulDescriptionAscType = 'contentfulDescription_ASC',
  ContentfulDescriptionDescType = 'contentfulDescription_DESC',
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  GroupKeyAscType = 'groupKey_ASC',
  GroupKeyDescType = 'groupKey_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export type CookieBannerFilterType = {
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly title_exists: InputMaybe<Scalars['Boolean']>;
  readonly title: InputMaybe<Scalars['String']>;
  readonly title_not: InputMaybe<Scalars['String']>;
  readonly title_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_contains: InputMaybe<Scalars['String']>;
  readonly title_not_contains: InputMaybe<Scalars['String']>;
  readonly leftMedia_exists: InputMaybe<Scalars['Boolean']>;
  readonly rightMedia_exists: InputMaybe<Scalars['Boolean']>;
  readonly body_exists: InputMaybe<Scalars['Boolean']>;
  readonly body_contains: InputMaybe<Scalars['String']>;
  readonly body_not_contains: InputMaybe<Scalars['String']>;
  readonly acceptCookiesButton_exists: InputMaybe<Scalars['Boolean']>;
  readonly acceptCookiesButton: InputMaybe<Scalars['String']>;
  readonly acceptCookiesButton_not: InputMaybe<Scalars['String']>;
  readonly acceptCookiesButton_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly acceptCookiesButton_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly acceptCookiesButton_contains: InputMaybe<Scalars['String']>;
  readonly acceptCookiesButton_not_contains: InputMaybe<Scalars['String']>;
  readonly cookieSettingsButtonText_exists: InputMaybe<Scalars['Boolean']>;
  readonly cookieSettingsButtonText: InputMaybe<Scalars['String']>;
  readonly cookieSettingsButtonText_not: InputMaybe<Scalars['String']>;
  readonly cookieSettingsButtonText_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly cookieSettingsButtonText_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly cookieSettingsButtonText_contains: InputMaybe<Scalars['String']>;
  readonly cookieSettingsButtonText_not_contains: InputMaybe<Scalars['String']>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<CookieBannerFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<CookieBannerFilterType>>>;
};

export enum CookieBannerOrderType {
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  AcceptCookiesButtonAscType = 'acceptCookiesButton_ASC',
  AcceptCookiesButtonDescType = 'acceptCookiesButton_DESC',
  CookieSettingsButtonTextAscType = 'cookieSettingsButtonText_ASC',
  CookieSettingsButtonTextDescType = 'cookieSettingsButtonText_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export type FooterFilterType = {
  readonly footerColumn: InputMaybe<CfFooterItemNestedFilterType>;
  readonly footerBar: InputMaybe<CfFooterItemNestedFilterType>;
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly title_exists: InputMaybe<Scalars['Boolean']>;
  readonly title: InputMaybe<Scalars['String']>;
  readonly title_not: InputMaybe<Scalars['String']>;
  readonly title_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_contains: InputMaybe<Scalars['String']>;
  readonly title_not_contains: InputMaybe<Scalars['String']>;
  readonly footerColumnCollection_exists: InputMaybe<Scalars['Boolean']>;
  readonly footerBarCollection_exists: InputMaybe<Scalars['Boolean']>;
  readonly globalOnly_exists: InputMaybe<Scalars['Boolean']>;
  readonly globalOnly: InputMaybe<Scalars['Boolean']>;
  readonly globalOnly_not: InputMaybe<Scalars['Boolean']>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<FooterFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<FooterFilterType>>>;
};

export enum FooterOrderType {
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  GlobalOnlyAscType = 'globalOnly_ASC',
  GlobalOnlyDescType = 'globalOnly_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export type AnalyticsCollectionType = {
  readonly __typename?: 'AnalyticsCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<AnalyticsType>>;
};

export enum AnalyticsOrderType {
  LabelAscType = 'label_ASC',
  LabelDescType = 'label_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export enum GlobalNavItemOrderType {
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  UrlAscType = 'url_ASC',
  UrlDescType = 'url_DESC',
  HideHostnameRegexAscType = 'hideHostnameRegex_ASC',
  HideHostnameRegexDescType = 'hideHostnameRegex_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export type ButtonFilterType = {
  readonly image: InputMaybe<CfImageNestedFilterType>;
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly contentfulDescription_exists: InputMaybe<Scalars['Boolean']>;
  readonly contentfulDescription: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_not: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentfulDescription_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentfulDescription_contains: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_not_contains: InputMaybe<Scalars['String']>;
  readonly title_exists: InputMaybe<Scalars['Boolean']>;
  readonly title_contains: InputMaybe<Scalars['String']>;
  readonly title_not_contains: InputMaybe<Scalars['String']>;
  readonly url_exists: InputMaybe<Scalars['Boolean']>;
  readonly url: InputMaybe<Scalars['String']>;
  readonly url_not: InputMaybe<Scalars['String']>;
  readonly url_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly url_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly url_contains: InputMaybe<Scalars['String']>;
  readonly url_not_contains: InputMaybe<Scalars['String']>;
  readonly size_exists: InputMaybe<Scalars['Boolean']>;
  readonly size: InputMaybe<Scalars['String']>;
  readonly size_not: InputMaybe<Scalars['String']>;
  readonly size_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly size_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly size_contains: InputMaybe<Scalars['String']>;
  readonly size_not_contains: InputMaybe<Scalars['String']>;
  readonly theme_exists: InputMaybe<Scalars['Boolean']>;
  readonly theme: InputMaybe<Scalars['String']>;
  readonly theme_not: InputMaybe<Scalars['String']>;
  readonly theme_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly theme_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly theme_contains: InputMaybe<Scalars['String']>;
  readonly theme_not_contains: InputMaybe<Scalars['String']>;
  readonly buttonType_exists: InputMaybe<Scalars['Boolean']>;
  readonly buttonType: InputMaybe<Scalars['String']>;
  readonly buttonType_not: InputMaybe<Scalars['String']>;
  readonly buttonType_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly buttonType_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly buttonType_contains: InputMaybe<Scalars['String']>;
  readonly buttonType_not_contains: InputMaybe<Scalars['String']>;
  readonly image_exists: InputMaybe<Scalars['Boolean']>;
  readonly iconName_exists: InputMaybe<Scalars['Boolean']>;
  readonly iconName: InputMaybe<Scalars['String']>;
  readonly iconName_not: InputMaybe<Scalars['String']>;
  readonly iconName_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly iconName_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly iconName_contains: InputMaybe<Scalars['String']>;
  readonly iconName_not_contains: InputMaybe<Scalars['String']>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<ButtonFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<ButtonFilterType>>>;
};

export enum ButtonOrderType {
  ContentfulDescriptionAscType = 'contentfulDescription_ASC',
  ContentfulDescriptionDescType = 'contentfulDescription_DESC',
  UrlAscType = 'url_ASC',
  UrlDescType = 'url_DESC',
  SizeAscType = 'size_ASC',
  SizeDescType = 'size_DESC',
  ThemeAscType = 'theme_ASC',
  ThemeDescType = 'theme_DESC',
  ButtonTypeAscType = 'buttonType_ASC',
  ButtonTypeDescType = 'buttonType_DESC',
  IconNameAscType = 'iconName_ASC',
  IconNameDescType = 'iconName_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export enum CallToActionOrderType {
  ContentfulDescriptionAscType = 'contentfulDescription_ASC',
  ContentfulDescriptionDescType = 'contentfulDescription_DESC',
  UrlAscType = 'url_ASC',
  UrlDescType = 'url_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

/** Common strings used across components with or without dynamic content. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/message) */
export type MessageType = EntryType & _NodeType & {
  readonly __typename?: 'Message';
  readonly sys: SysType;
  readonly contentfulMetadata: ContentfulMetadataType;
  readonly linkedFrom: Maybe<MessageLinkingCollectionsType>;
  readonly _id: Scalars['ID'];
  readonly title: Maybe<Scalars['String']>;
  readonly key: Maybe<Scalars['String']>;
  readonly value: Maybe<Scalars['String']>;
};


/** Common strings used across components with or without dynamic content. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/message) */
export type MessageLinkedFromArgsType = {
  allowedLocales: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


/** Common strings used across components with or without dynamic content. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/message) */
export type MessageTitleArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** Common strings used across components with or without dynamic content. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/message) */
export type MessageKeyArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** Common strings used across components with or without dynamic content. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/message) */
export type MessageValueArgsType = {
  locale: InputMaybe<Scalars['String']>;
};

export type MessageLinkingCollectionsType = {
  readonly __typename?: 'MessageLinkingCollections';
  readonly entryCollection: Maybe<EntryCollectionType>;
};


export type MessageLinkingCollectionsEntryCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};

export type MessageCollectionType = {
  readonly __typename?: 'MessageCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<MessageType>>;
};

export type MessageFilterType = {
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly title_exists: InputMaybe<Scalars['Boolean']>;
  readonly title: InputMaybe<Scalars['String']>;
  readonly title_not: InputMaybe<Scalars['String']>;
  readonly title_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title_contains: InputMaybe<Scalars['String']>;
  readonly title_not_contains: InputMaybe<Scalars['String']>;
  readonly key_exists: InputMaybe<Scalars['Boolean']>;
  readonly key: InputMaybe<Scalars['String']>;
  readonly key_not: InputMaybe<Scalars['String']>;
  readonly key_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly key_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly key_contains: InputMaybe<Scalars['String']>;
  readonly key_not_contains: InputMaybe<Scalars['String']>;
  readonly value_exists: InputMaybe<Scalars['Boolean']>;
  readonly value: InputMaybe<Scalars['String']>;
  readonly value_not: InputMaybe<Scalars['String']>;
  readonly value_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly value_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly value_contains: InputMaybe<Scalars['String']>;
  readonly value_not_contains: InputMaybe<Scalars['String']>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<MessageFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<MessageFilterType>>>;
};

export enum MessageOrderType {
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  KeyAscType = 'key_ASC',
  KeyDescType = 'key_DESC',
  ValueAscType = 'value_ASC',
  ValueDescType = 'value_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

/** Common strings used across components with or without dynamic content. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/legalMessage) */
export type LegalMessageType = EntryType & _NodeType & {
  readonly __typename?: 'LegalMessage';
  readonly sys: SysType;
  readonly contentfulMetadata: ContentfulMetadataType;
  readonly linkedFrom: Maybe<LegalMessageLinkingCollectionsType>;
  readonly _id: Scalars['ID'];
  readonly key: Maybe<Scalars['String']>;
  readonly value: Maybe<Scalars['String']>;
};


/** Common strings used across components with or without dynamic content. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/legalMessage) */
export type LegalMessageLinkedFromArgsType = {
  allowedLocales: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


/** Common strings used across components with or without dynamic content. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/legalMessage) */
export type LegalMessageKeyArgsType = {
  locale: InputMaybe<Scalars['String']>;
};


/** Common strings used across components with or without dynamic content. [See type definition](https://app.contentful.com/spaces/kp51zybwznx4/content_types/legalMessage) */
export type LegalMessageValueArgsType = {
  locale: InputMaybe<Scalars['String']>;
};

export type LegalMessageLinkingCollectionsType = {
  readonly __typename?: 'LegalMessageLinkingCollections';
  readonly entryCollection: Maybe<EntryCollectionType>;
};


export type LegalMessageLinkingCollectionsEntryCollectionArgsType = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  preview: InputMaybe<Scalars['Boolean']>;
  locale: InputMaybe<Scalars['String']>;
};

export type LegalMessageCollectionType = {
  readonly __typename?: 'LegalMessageCollection';
  readonly total: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly items: ReadonlyArray<Maybe<LegalMessageType>>;
};

export type LegalMessageFilterType = {
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly key_exists: InputMaybe<Scalars['Boolean']>;
  readonly key: InputMaybe<Scalars['String']>;
  readonly key_not: InputMaybe<Scalars['String']>;
  readonly key_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly key_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly key_contains: InputMaybe<Scalars['String']>;
  readonly key_not_contains: InputMaybe<Scalars['String']>;
  readonly value_exists: InputMaybe<Scalars['Boolean']>;
  readonly value: InputMaybe<Scalars['String']>;
  readonly value_not: InputMaybe<Scalars['String']>;
  readonly value_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly value_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly value_contains: InputMaybe<Scalars['String']>;
  readonly value_not_contains: InputMaybe<Scalars['String']>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<LegalMessageFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<LegalMessageFilterType>>>;
};

export enum LegalMessageOrderType {
  KeyAscType = 'key_ASC',
  KeyDescType = 'key_DESC',
  ValueAscType = 'value_ASC',
  ValueDescType = 'value_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export type VideoFilterType = {
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly contentfulDescription_exists: InputMaybe<Scalars['Boolean']>;
  readonly contentfulDescription: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_not: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentfulDescription_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly contentfulDescription_contains: InputMaybe<Scalars['String']>;
  readonly contentfulDescription_not_contains: InputMaybe<Scalars['String']>;
  readonly media_exists: InputMaybe<Scalars['Boolean']>;
  readonly thumbnailMedia_exists: InputMaybe<Scalars['Boolean']>;
  readonly autoPlay_exists: InputMaybe<Scalars['Boolean']>;
  readonly autoPlay: InputMaybe<Scalars['Boolean']>;
  readonly autoPlay_not: InputMaybe<Scalars['Boolean']>;
  readonly wrap_exists: InputMaybe<Scalars['Boolean']>;
  readonly wrap: InputMaybe<Scalars['String']>;
  readonly wrap_not: InputMaybe<Scalars['String']>;
  readonly wrap_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly wrap_not_in: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly wrap_contains: InputMaybe<Scalars['String']>;
  readonly wrap_not_contains: InputMaybe<Scalars['String']>;
  readonly captions_exists: InputMaybe<Scalars['Boolean']>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<VideoFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<VideoFilterType>>>;
};

export enum VideoOrderType {
  ContentfulDescriptionAscType = 'contentfulDescription_ASC',
  ContentfulDescriptionDescType = 'contentfulDescription_DESC',
  AutoPlayAscType = 'autoPlay_ASC',
  AutoPlayDescType = 'autoPlay_DESC',
  WrapAscType = 'wrap_ASC',
  WrapDescType = 'wrap_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export enum FooterItemOrderType {
  TitleAscType = 'title_ASC',
  TitleDescType = 'title_DESC',
  UrlAscType = 'url_ASC',
  UrlDescType = 'url_DESC',
  GlobalOnlyAscType = 'globalOnly_ASC',
  GlobalOnlyDescType = 'globalOnly_DESC',
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export type EntryFilterType = {
  readonly sys: InputMaybe<SysFilterType>;
  readonly contentfulMetadata: InputMaybe<ContentfulMetadataFilterType>;
  readonly OR: InputMaybe<ReadonlyArray<InputMaybe<EntryFilterType>>>;
  readonly AND: InputMaybe<ReadonlyArray<InputMaybe<EntryFilterType>>>;
};

export enum EntryOrderType {
  SysIdAscType = 'sys_id_ASC',
  SysIdDescType = 'sys_id_DESC',
  SysPublishedAtAscType = 'sys_publishedAt_ASC',
  SysPublishedAtDescType = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAscType = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDescType = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAscType = 'sys_publishedVersion_ASC',
  SysPublishedVersionDescType = 'sys_publishedVersion_DESC'
}

export type CookieModalQueryVariablesType = Exact<{
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type CookieModalQueryType = { readonly __typename?: 'Query', readonly cookieModalCollection: { readonly __typename?: 'CookieModalCollection', readonly items: ReadonlyArray<{ readonly __typename?: 'CookieModal', readonly landingScreenTitle: string, readonly acceptAllButtonText: string, readonly essentialOnlyButtonText: string, readonly settingsButtonText: string, readonly settingsScreenTitle: string, readonly acceptSelectedButtonText: string, readonly saveChangesText: string, readonly changesSavedText: string, readonly toggleEnabledText: string, readonly toggleDisabledText: string, readonly gpcLocations: ReadonlyArray<string>, readonly enableCookieDeletion: boolean, readonly sys: { readonly __typename?: 'Sys', readonly id: string }, readonly content: { readonly __typename?: 'CookieModalContent', readonly json: Record<string, unknown> }, readonly cookieCategoriesCollection: { readonly __typename?: 'CookieModalCookieCategoriesCollection', readonly items: ReadonlyArray<{ readonly __typename?: 'CookieCategory', readonly title: string, readonly categoryCookieName: string, readonly displayMode: string, readonly isEssential: boolean, readonly enableToggle: boolean, readonly sys: { readonly __typename?: 'Sys', readonly id: string }, readonly description: { readonly __typename?: 'CookieCategoryDescription', readonly json: Record<string, unknown> }, readonly cookiesCollection: { readonly __typename?: 'CookieCategoryCookiesCollection', readonly items: ReadonlyArray<{ readonly __typename?: 'TrackingCookie', readonly name: string, readonly pattern: string, readonly subDomains: ReadonlyArray<string>, readonly path: string, readonly secure: boolean, readonly sameSite: string, readonly sys: { readonly __typename?: 'Sys', readonly id: string }, readonly provider: { readonly __typename?: 'TrackingCookieProvider', readonly json: Record<string, unknown> }, readonly domains: { readonly __typename?: 'TrackingCookieDomains', readonly json: Record<string, unknown> }, readonly purpose: { readonly __typename?: 'TrackingCookiePurpose', readonly json: Record<string, unknown> }, readonly expiration: { readonly __typename?: 'TrackingCookieExpiration', readonly json: Record<string, unknown> } }> } }> } }> } };

export type CookieModalAllType = { readonly __typename?: 'CookieModal', readonly landingScreenTitle: string, readonly acceptAllButtonText: string, readonly essentialOnlyButtonText: string, readonly settingsButtonText: string, readonly settingsScreenTitle: string, readonly acceptSelectedButtonText: string, readonly saveChangesText: string, readonly changesSavedText: string, readonly toggleEnabledText: string, readonly toggleDisabledText: string, readonly gpcLocations: ReadonlyArray<string>, readonly enableCookieDeletion: boolean, readonly sys: { readonly __typename?: 'Sys', readonly id: string }, readonly content: { readonly __typename?: 'CookieModalContent', readonly json: Record<string, unknown> }, readonly cookieCategoriesCollection: { readonly __typename?: 'CookieModalCookieCategoriesCollection', readonly items: ReadonlyArray<{ readonly __typename?: 'CookieCategory', readonly title: string, readonly categoryCookieName: string, readonly displayMode: string, readonly isEssential: boolean, readonly enableToggle: boolean, readonly sys: { readonly __typename?: 'Sys', readonly id: string }, readonly description: { readonly __typename?: 'CookieCategoryDescription', readonly json: Record<string, unknown> }, readonly cookiesCollection: { readonly __typename?: 'CookieCategoryCookiesCollection', readonly items: ReadonlyArray<{ readonly __typename?: 'TrackingCookie', readonly name: string, readonly pattern: string, readonly subDomains: ReadonlyArray<string>, readonly path: string, readonly secure: boolean, readonly sameSite: string, readonly sys: { readonly __typename?: 'Sys', readonly id: string }, readonly provider: { readonly __typename?: 'TrackingCookieProvider', readonly json: Record<string, unknown> }, readonly domains: { readonly __typename?: 'TrackingCookieDomains', readonly json: Record<string, unknown> }, readonly purpose: { readonly __typename?: 'TrackingCookiePurpose', readonly json: Record<string, unknown> }, readonly expiration: { readonly __typename?: 'TrackingCookieExpiration', readonly json: Record<string, unknown> } }> } }> } };

export type CookieCategoryAllType = { readonly __typename?: 'CookieCategory', readonly title: string, readonly categoryCookieName: string, readonly displayMode: string, readonly isEssential: boolean, readonly enableToggle: boolean, readonly sys: { readonly __typename?: 'Sys', readonly id: string }, readonly description: { readonly __typename?: 'CookieCategoryDescription', readonly json: Record<string, unknown> }, readonly cookiesCollection: { readonly __typename?: 'CookieCategoryCookiesCollection', readonly items: ReadonlyArray<{ readonly __typename?: 'TrackingCookie', readonly name: string, readonly pattern: string, readonly subDomains: ReadonlyArray<string>, readonly path: string, readonly secure: boolean, readonly sameSite: string, readonly sys: { readonly __typename?: 'Sys', readonly id: string }, readonly provider: { readonly __typename?: 'TrackingCookieProvider', readonly json: Record<string, unknown> }, readonly domains: { readonly __typename?: 'TrackingCookieDomains', readonly json: Record<string, unknown> }, readonly purpose: { readonly __typename?: 'TrackingCookiePurpose', readonly json: Record<string, unknown> }, readonly expiration: { readonly __typename?: 'TrackingCookieExpiration', readonly json: Record<string, unknown> } }> } };

export type TrackingCookieAllType = { readonly __typename?: 'TrackingCookie', readonly name: string, readonly pattern: string, readonly subDomains: ReadonlyArray<string>, readonly path: string, readonly secure: boolean, readonly sameSite: string, readonly sys: { readonly __typename?: 'Sys', readonly id: string }, readonly provider: { readonly __typename?: 'TrackingCookieProvider', readonly json: Record<string, unknown> }, readonly domains: { readonly __typename?: 'TrackingCookieDomains', readonly json: Record<string, unknown> }, readonly purpose: { readonly __typename?: 'TrackingCookiePurpose', readonly json: Record<string, unknown> }, readonly expiration: { readonly __typename?: 'TrackingCookieExpiration', readonly json: Record<string, unknown> } };

export const TrackingCookieAllType = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TrackingCookieAll"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TrackingCookie"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}}]}},{"kind":"Field","name":{"kind":"Name","value":"domains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}}]}},{"kind":"Field","name":{"kind":"Name","value":"purpose"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expiration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pattern"}},{"kind":"Field","name":{"kind":"Name","value":"subDomains"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"secure"}},{"kind":"Field","name":{"kind":"Name","value":"sameSite"}}]}}]} as unknown as DocumentNode<TrackingCookieAllType, unknown>;
export const CookieCategoryAllType = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CookieCategoryAll"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CookieCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoryCookieName"}},{"kind":"Field","name":{"kind":"Name","value":"displayMode"}},{"kind":"Field","name":{"kind":"Name","value":"isEssential"}},{"kind":"Field","name":{"kind":"Name","value":"enableToggle"}},{"kind":"Field","name":{"kind":"Name","value":"cookiesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"200"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrackingCookieAll"}}]}}]}}]}}]} as unknown as DocumentNode<CookieCategoryAllType, unknown>;
export const CookieModalAllType = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CookieModalAll"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CookieModal"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"landingScreenTitle"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}}]}},{"kind":"Field","name":{"kind":"Name","value":"acceptAllButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"essentialOnlyButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"settingsButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"settingsScreenTitle"}},{"kind":"Field","name":{"kind":"Name","value":"cookieCategoriesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CookieCategoryAll"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"acceptSelectedButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"saveChangesText"}},{"kind":"Field","name":{"kind":"Name","value":"changesSavedText"}},{"kind":"Field","name":{"kind":"Name","value":"toggleEnabledText"}},{"kind":"Field","name":{"kind":"Name","value":"toggleDisabledText"}},{"kind":"Field","name":{"kind":"Name","value":"gpcLocations"}},{"kind":"Field","name":{"kind":"Name","value":"enableCookieDeletion"}}]}}]} as unknown as DocumentNode<CookieModalAllType, unknown>;
export const CookieModalQueryDocumentType = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CookieModalQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preview"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cookieModalCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CookieModalAll"}}]}}]}}]}},...CookieModalAllType.definitions,...CookieCategoryAllType.definitions,...TrackingCookieAllType.definitions]} as unknown as DocumentNode<CookieModalQueryType, CookieModalQueryVariablesType>;